
export default {
    groupComponents: {
        title: "Group Components",
        weight: 1,
        components: {
            fullName: {
                title: "Full Name",
                icon: "id-badge",
                hideLabel: true,
                schema: {
                    label: "Full Name",
                    hideLabel: true,
                    input: false,
                    components: [
                        {
                            type: "columns",
                            autoAdjust: true,
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 4,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "firstName",
                                            case: "uppercase",
                                            type: "textfield",
                                            input: true,
                                            label: "First Name",
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters and spaces."
                                            },
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 4
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 4,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "middleName",
                                            case: "uppercase",
                                            type: "textfield",
                                            input: true,
                                            label: "Middle Name",
                                            errors: {
                                                pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters and spaces."
                                            },
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                            },
                                            tableView: true,
                                            customClass: ""
                                        }
                                    ],
                                    currentWidth: 4
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 4,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "lastName",
                                            case: "uppercase",
                                            type: "textfield",
                                            input: true,
                                            label: "Last Name",
                                            errors: {
                                                pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters and spaces."
                                            },
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 4
                                }
                            ],
                            key: "fullNameColumns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            addressForCommunication: {
                title: "Address",
                icon: "map-marker",
                schema: {
                    title: "Address for Communication",
                    theme: "primary",
                    collapsible: false,
                    key: "addressForCommunication",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    components: [
                                    {
                                        label: "Present Address 1",
                                        placeholder: "Enter here",
                                        autoExpand: false,
                                        validate: {
                                            required: true,
                                            pattern: "^[a-zA-Z0-9.,#-/]+(?: [a-zA-Z0-9.,#-/]+)*$"
                                        },
                                        errors: {
                                            required: "{{ field }} is required.",
                                            pattern: "Invalid address format. Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                        },
                                        key: "presentAddress1",
                                        type: "textfield",
                                        input: true,
                                        tableView: true
                                    }
                                    ],
                                    currentWidth: 12
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    components: [
                                    {
                                        label: "Present Address 2",
                                        placeholder: "Enter here",
                                        autoExpand: false,
                                        validate: {
                                            pattern: "^[a-zA-Z0-9.,#-/]+(?: [a-zA-Z0-9.,#-/]+)*$"
                                        },
                                        errors: {
                                            pattern: "Invalid address format. Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                        },
                                        key: "presentAddress2",
                                        type: "textfield",
                                        input: true,
                                        tableView: true
                                    }
                                    ],
                                    currentWidth: 12
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    components: [
                                    {
                                        label: "Present Address 3",
                                        placeholder: "Enter here",
                                        autoExpand: false,
                                        validate: {
                                            pattern: "^[a-zA-Z0-9.,#-/]+(?: [a-zA-Z0-9.,#-/]+)*$"
                                        },
                                        errors: {
                                            pattern: "Invalid address format. Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                        },
                                        key: "presentAddress3",
                                        type: "textfield",
                                        input: true,
                                        tableView: true
                                    }
                                    ],
                                    currentWidth: 12
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Present Country/Region",
                                            placeholder: "--Select--",
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/country",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            valueProperty: "value.id",
                                            validate: {
                                                required: true
                                            },
                                            key: "presentCountryRegion",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            noRefreshOnScroll: false,
                                            input: true,
                                            idPath: "value",
                                            widget: "choicesjs",
                                            dataType: "object",
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Present State/Province",
                                            placeholder: "--Select--",
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/state?country={{ data.presentCountryRegion.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            valueProperty: "value.id",
                                            refreshOn: "presentCountryRegion",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "presentStateProvince",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            widget: "choicesjs",
                                            tableView: true,
                                            dataType: "object",
                                            idPath: "value",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Present City",
                                            placeholder: "--Select--",
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/district?state={{ data.presentStateProvince.id }}",
                                                headers: [
                                                    {
                                                    key: "Authorization",
                                                    value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            valueProperty: "value.id",
                                            refreshOn: "presentStateProvince",
                                            clearOnRefresh: true,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "presentCity",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            widget: "choicesjs",
                                            tableView: true,
                                            dataType: "object",
                                            idPath: "value",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Present Postal/Zip code",
                                            placeholder: "Enter here",
                                            delimiter: false,
                                            requireDecimal: false,
                                            truncateMultipleSpaces: false,
                                            validate: {
                                                required: true,
                                                pattern: "^[0-9]{6}$"
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please enter a 6 digit PIN code"
                                            },
                                            key: "presentPostalZipcode",
                                            type: "number",
                                            input: true,
                                            tableView: true,
                                            autoExpand: false
                                        }
                                    ],
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "presentColumns",
                            type: "columns",
                            tableView: false,
                            input: false
                        },
                        {
                            label: "Same as present address",
                            key: "isSame",
                            type: "checkbox",
                            input: true,
                            tableView: true,
                            autoExpand: false,
                            defaultValue: false
                        },
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Permanent Address 1",
                                            placeholder: "Enter here",
                                            autoExpand: false,
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,#-/]+(?: [a-zA-Z0-9.,#-/]+)*$"
                                            },
                                            errors: {
                                                pattern: "Invalid address format. Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                            },
                                            key: "permanentAddress1",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Permanent Address 2",
                                            placeholder: "Enter here",
                                            autoExpand: false,
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,#-/]+(?: [a-zA-Z0-9.,#-/]+)*$"
                                            },
                                            errors: {
                                                pattern: "Invalid address format. Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                            },
                                            key: "permanentAddress2",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Permanent Address 3",
                                            placeholder: "Enter here",
                                            autoExpand: false,
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,#-/]+(?: [a-zA-Z0-9.,#-/]+)*$"
                                            },
                                            errors: {
                                                pattern: "Invalid address format. Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                            },
                                            key: "permanentAddress3",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                    }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Permanent Country/Region",
                                            placeholder: "--Select--",
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/country",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            valueProperty: "value.id",
                                            key: "permanentCountryRegion",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            noRefreshOnScroll: false,
                                            input: true,
                                            idPath: "value",
                                            widget: "choicesjs",
                                            dataType: "object",
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Permanent State/Province",
                                            placeholder: "--Select--",
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/state?country={{ data.permanentCountryRegion.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            valueProperty: "value.id",
                                            refreshOn: "permanentCountryRegion",
                                            key: "permanentStateProvince",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            input: true,
                                            idPath: "value",
                                            widget: "choicesjs",
                                            dataType: "object",
                                            tableView: true,
                                            noRefreshOnScroll: false
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Permanent City",
                                            placeholder: "--Select--",
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/district?state={{ data.permanentStateProvince.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            valueProperty: "value.id",
                                            refreshOn: "permanentStateProvince",
                                            key: "permanentCity",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            noRefreshOnScroll: false,
                                            input: true,
                                            idPath: "value",
                                            widget: "choicesjs",
                                            dataType: "object",
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Permanent Postal/Zip code",
                                            placeholder: "Enter here",
                                            delimiter: false,
                                            requireDecimal: false,
                                            truncateMultipleSpaces: false,
                                            validate: {
                                                pattern: "^[0-9]{6}$"
                                            },
                                            errors: {
                                                pattern: "Please enter a 6 digit PIN code"
                                            },
                                            key: "permanentPostalZipcode",
                                            type: "number",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            key: "permanentColumns",
                            conditional: {
                                show: true,
                                when: "isSame",
                                eq: "false"
                            },
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            emailConfirmEmailAddress: {
                title: "Email Address",
                icon: "at",
                schema: {
                    title: "Email Address",
                    collapsible: false,
                    hideLabel: true,
                    key: "emailConfirmEmailAddress",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            key: "emailAddress",
                                            type: "email",
                                            input: true,
                                            label: "Email Address",
                                            errors: {
                                                custom: "{{ field }} is already exist.",
                                                required: "{{ field }} is required."
                                            },
                                            unique: true,
                                            validate: {
                                                required: true
                                            },
                                            tableView: true
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            key: "confirmEmailAddress",
                                            type: "email",
                                            input: true,
                                            label: "Confirm Email Address",
                                            errors: {
                                                custom: "Please ensure that the email and confirm email fields match.",
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                custom: "valid = (data.confirmEmailAddress === data.emailAddress)? true : false;",
                                                required: true
                                            },
                                            tableView: true
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "emailIdColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            personalDetails: {
                title: "Personal Details",
                icon: "user",
                schema: {
                    title: "Personal Details",
                    theme: "primary",
                    collapsible: false,
                    key: "personalDetails",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Name (as per Aadhar)",
                                            placeholder: "Enter here",
                                            case: "uppercase",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters, spaces, dots, and hyphens."
                                            },
                                            key: "nameAsPerAadhar",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    width: 8,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 8
                                },
                                {
                                    components: [
                                        {
                                            label: "Upload Profile Photo",
                                            description: "JPG, JPEG and PNG only supported\r\nSize: Maximum 200KB",
                                            dir: "profile-photo",
                                            url: `storage/azure?_token={{csrfToken}}&exts=jpeg,jpg,png&dms=139*179&checkFaceDetection=true`,
                                            hideLabel: true,
                                            tableView: false,
                                            webcam: false,
                                            storage: "url",
                                            fileTypes: [
                                                {
                                                    label: "JPG",
                                                    value: "jpg"
                                                },
                                                {
                                                    label: "JPEG",
                                                    value: "jpeg"
                                                },
                                                {
                                                    label: "PNG",
                                                    value: "png"
                                                }
                                            ],
                                            imageSize: "139",
                                            fileMaxSize: "200KB",
                                            fileMinSize: "5KB",
                                            validate: {
                                                required: true
                                            },
                                            key: "uploadProfilePhoto",
                                            type: "file",
                                            input: true
                                        }
                                    ],
                                    width: 4,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 4
                                },
                                {
                                    components: [
                                        {
                                            label: "Email ID",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                maxLength: 150
                                            },
                                            unique: true,
                                            errors: {
                                                custom: "{{ field }} is already exist.",
                                                required: "{{ field }} is required."
                                            },
                                            key: "emailId",
                                            type: "email",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Mobile No.",
                                            prefix: "+91",
                                            inputMask: "9999999999",
                                            displayMask: "9999999999",
                                            validate: {
                                                required: true,
                                                pattern: "^[6-9]\\d{9}$"
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                mask: "Only numbers are allowed.",
                                                pattern: "Please enter a 10-digit mobile number starting with 6, 7, 8, or 9."
                                            },
                                            key: "mobileNo",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Aadhar No.",
                                            inputMask: "9999 9999 9999",
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                mask: "Please enter valid {{ field }}."
                                            },
                                            key: "aadharNo",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Do you have PAN card",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "Applied",
                                                        value: "Applied"
                                                    }
                                                ]
                                            },
                                            validate: {
                                                required: true
                                            },
                                            key: "doYouHavePanCard",
                                            type: "select",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "PAN No.",
                                            inputMask: "AAAAA9999A",
                                            case: "uppercase",
                                            validate: {
                                                required: true,
                                            },
                                            errors: {
                                                mask: "Please enter a valid {{ field }}"
                                            },
                                            key: "pancardNo",
                                            conditional: {
                                                show: true,
                                                when: "doYouHavePanCard",
                                                eq: "Yes"
                                            },
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Applied Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "appliedDate",
                                            conditional: {
                                                show: true,
                                                when: "doYouHavePanCard",
                                                eq: "Applied"
                                            },
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Application No",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[a-zA-Z0-9]+$",
                                                maxLength: 25
                                            },
                                            errors: {
                                                pattern: "Please enter a valid {{ field }}"
                                            },
                                            key: "applicationNo",
                                            conditional: {
                                                show: true,
                                                when: "doYouHavePanCard",
                                                eq: "Applied"
                                            },
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Date of Birth (as per Std X certificate)",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "dateOfBirth",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Gender",
                                            placeholder: "--Select--",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Male",
                                                        value: "Male"
                                                    },
                                                    {
                                                        label: "Female",
                                                        value: "Female"
                                                    },
                                                    {
                                                        label: "Others",
                                                        value: "Others"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "gender",
                                            type: "select",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Marital Status",
                                            placeholder: "--Select--",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Single",
                                                        value: "Single"
                                                    },
                                                    {
                                                        label: "Married",
                                                        value: "Married"
                                                    },
                                                    {
                                                        label: "Widow",
                                                        value: "Widow"
                                                    },
                                                    {
                                                        label: "Divorced",
                                                        value: "Divorced"
                                                    },
                                                    {
                                                        label: "Separated",
                                                        value: "Separated"
                                                    },
                                                    {
                                                        label: "Others",
                                                        value: "Others"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "maritalStatus",
                                            type: "select",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "No. of Children",
                                            data: {
                                                values: [
                                                    {
                                                        label: "0",
                                                        value: "0"
                                                    },
                                                    {
                                                        label: "1",
                                                        value: "1"
                                                    },
                                                    {
                                                        label: "2",
                                                        value: "2"
                                                    },
                                                    {
                                                        label: "3",
                                                        value: "3"
                                                    },
                                                    {
                                                        label: "4",
                                                        value: "4"
                                                    },
                                                    {
                                                        label: "5",
                                                        value: "5"
                                                    }
                                                ]
                                            },
                                            validate: {
                                                required: true
                                            },
                                            key: "noOfChildren",
                                            customConditional: "show = !!data.maritalStatus && (data.maritalStatus === 'Married' || data.maritalStatus === 'Widow')",
                                            type: "select",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Domicile State",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: `BASE_URL/api/state?country=101`,
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "domicileState",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Place of Birth",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 100
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "placeOfBirth",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "State of Birth",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: `BASE_URL/api/state?country=101`,
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "stateOfBirth",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Nationality",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 100
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "nationality",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Religion",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 100
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "religion",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Blood Group",
                                            placeholder: "--Select--",
                                            data: {
                                                values: [
                                                    {
                                                        label: "A+",
                                                        value: "A+"
                                                    },
                                                    {
                                                        label: "A-",
                                                        value: "A-"
                                                    },
                                                    {
                                                        label: "B+",
                                                        value: "B+"
                                                    },
                                                    {
                                                        label: "B-",
                                                        value: "B-"
                                                    },
                                                    {
                                                        label: "O+",
                                                        value: "O+"
                                                    },
                                                    {
                                                        label: "O-",
                                                        value: "O-"
                                                    },
                                                    {
                                                        label: "AB+",
                                                        value: "AB+"
                                                    },
                                                    {
                                                        label: "AB-",
                                                        value: "AB-"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            key: "bloodGroup",
                                            type: "select",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Community",
                                            placeholder: "--Select--",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Scheduled Caste",
                                                        value: "Scheduled Caste"
                                                    },
                                                    {
                                                        label: "Scheduled Tribe",
                                                        value: "Scheduled Tribe"
                                                    },
                                                    {
                                                        label: "De-notified Tribe",
                                                        value: "De-notified Tribe"
                                                    },
                                                    {
                                                        label: "Nomadic Tribe",
                                                        value: "Nomadic Tribe"
                                                    },
                                                    {
                                                        label: "Special Backward Category",
                                                        value: "Special Backward Category"
                                                    },
                                                    {
                                                        label: "Other Backward Classes",
                                                        value: "Other Backward Classes"
                                                    },
                                                    {
                                                        label: "General / Open Category",
                                                        value: "General / Open Category"
                                                    },
                                                    {
                                                        label: "Other",
                                                        value: "Other"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            key: "community",
                                            type: "select",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Caste Name",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 100
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "casteName",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Father Name",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "fatherName",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Emergency Contact No.",
                                            prefix: "+91",
                                            inputMask: "9999999999",
                                            displayMask: "9999999999",
                                            validate: {
                                                required: true,
                                                pattern: "^[6-9]\\d{9}$"
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                mask: "Only numbers are allowed.",
                                                pattern: "Please enter a 10-digit mobile number starting with 6, 7, 8, or 9."
                                            },
                                            key: "emergencyContactNo",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Emergency Contact Person Name",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "emergencyContactPersonName",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Relation with Emergency Contact",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "relationWithEmergencyContact",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Alternate Email ID",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                maxLength: 150
                                            },
                                            unique: true,
                                            errors: {
                                                custom: "{{ field }} is already exist.",
                                                required: "{{ field }} is required."
                                            },
                                            key: "alternateEmailId",
                                            type: "email",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Offer Reference",
                                            placeholder: "Enter here",
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,-_']+(?: [a-zA-Z0-9.,-_']+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "offerReference",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Offer Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "offerDate",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "personalDetailsColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            language: {
                title: "Language",
                icon: "language",
                schema: {
                    title: "Languages",
                    theme: "primary",
                    collapsible: false,
                    key: "languages",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Mother Tongue",
                                            placeholder: "Mother Tongue",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 50
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "motherTongue",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Read",
                                            customClass: "mt-5",
                                            tableView: false,
                                            defaultValue: false,
                                            key: "motherTongueRead",
                                            type: "checkbox",
                                            input: true
                                        }
                                    ],
                                    width: 2,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 2
                                },
                                {
                                    components: [
                                        {
                                            label: "Write",
                                            customClass: "mt-5",
                                            tableView: false,
                                            defaultValue: false,
                                            key: "motherTongueWrite",
                                            type: "checkbox",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 2,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 2
                                },
                                {
                                    components: [
                                        {
                                            label: "Speak",
                                            customClass: "mt-5",
                                            tableView: false,
                                            defaultValue: false,
                                            key: "motherTongueSpeak",
                                            type: "checkbox",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 2,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 2
                                }
                            ],
                            autoAdjust: true,
                            key: "languageColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        },
                        {
                            label: "Other Languages",
                            reorder: false,
                            addAnother: "Add Language",
                            addAnotherPosition: "bottom",
                            layoutFixed: false,
                            enableRowGroups: false,
                            initEmpty: false,
                            tableView: false,
                            key: "otherLanguages",
                            type: "datagrid",
                            input: false,
                            theme: "primary",
                            title: "other Languages Details",
                            components: [
                                {
                                    label: "Columns",
                                    columns: [
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 6,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Language",
                                                    placeholder: "Language Name",
                                                    hideLabel: true,
                                                    tableView: true,
                                                    customClass: "mt-1",
                                                    validate: {
                                                        required: true,
                                                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                        maxLength: 50
                                                    },
                                                    errors: {
                                                        required: "{{ field }} is required.",
                                                        pattern: "Please use only alphabetic characters and spaces."
                                                    },
                                                    key: "otherLanguages",
                                                    type: "textfield",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 6
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 2,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Read",
                                                    customClass: "mt-2",
                                                    tableView: false,
                                                    defaultValue: false,
                                                    key: "otherLanguagesRead",
                                                    type: "checkbox",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 2
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 2,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Write",
                                                    customClass: "mt-2",
                                                    tableView: false,
                                                    defaultValue: false,
                                                    key: "otherLanguagesWrite",
                                                    type: "checkbox",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 2
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 2,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Speak",
                                                    customClass: "mt-2",
                                                    tableView: false,
                                                    defaultValue: false,
                                                    key: "otherLanguagesSpeak",
                                                    type: "checkbox",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 2
                                        }
                                    ],
                                    autoAdjust: true,
                                    hideLabel: true,
                                    key: "otherLanguagesColumns",
                                    type: "columns",
                                    input: false,
                                    tableView: false
                                }
                            ]
                        }
                    ]
                }
            },
            passportDetails: {
                title: "Passport Details",
                icon: "globe",
                schema: {
                    title: "Passport Details",
                    theme: "primary",
                    collapsible: false,
                    key: "passportDetails",
                    type: "panel",
                    label: "Passport Details",
                    input: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Passport Number",
                                            placeholder: "Enter here",
                                            inputMask: "AA999999",
                                            validate: {
                                                pattern: "^[A-Za-z0-9]{6,20}$"
                                            },
                                            errors: {
                                                pattern: "Please enter a valid Passport number"
                                            },
                                            key: "passportNumber",
                                            case: "uppercase",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Name as in Passport",
                                            placeholder: "Enter here",
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces"
                                            },
                                            key: "nameAsInPassport",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Profession as in Passport",
                                            placeholder: "Enter here",
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces"
                                            },
                                            key: "professionAsInPassport",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Issued Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            timePicker: {
                                                showMeridian: false
                                            },
                                            clearOnHide: false,
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "issuedDate",
                                            type: "datetime",
                                            input: false,
                                            tableView: false,
                                            template: "<div><label>Issued Date</label><input type='date' ref='input' readonly class='form-control col-md-6' required></div>",
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: true,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Valid Upto",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            timePicker: {
                                                showMeridian: false
                                            },
                                            clearOnHide: false,
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "validUpto",
                                            type: "datetime",
                                            input: false,
                                            tableView: false,
                                            template: "<div><label>Valid Upto</label><input type='date' ref='input' readonly class='form-control col-md-6' required></div>",
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: true,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Place of Issue",
                                            placeholder: "Enter here",
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces"
                                            },
                                            key: "placeOfIssue",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Countries Valid for",
                                            placeholder: "Enter here",
                                            validate: {
                                                pattern: "^[a-zA-Z0-9,&]+(?: [a-zA-Z0-9,&]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces"
                                            },
                                            key: "countriesValidfor",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "passportDetailsColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    tableView: false
                }
            },
            healthDetails: {
                title: "Health Related Details",
                icon: "heartbeat",
                schema: {
                    title: "Health Related Details",
                    theme: "primary",
                    collapsible: false,
                    key: "healthDetails",
                    type: "panel",
                    label: "Health Related Details",
                    input: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "mostSeriousRecentIllness",
                                            type: "textfield",
                                            input: true,
                                            label: "Most Serious Recent Illness",
                                            placeholder: "Enter here",
                                            errors: {
                                                pattern: "Please enter valid {{field}}."
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 150
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "noOfDaysIll",
                                            type: "number",
                                            input: true,
                                            label: "No. of Days Ill",
                                            placeholder: "Enter here",
                                            validate: {
                                                min: 0,
                                                max: 90
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "natureOfIllness",
                                            type: "textfield",
                                            input: true,
                                            label: "Nature of Illness",
                                            placeholder: "Enter here",
                                            errors: {
                                                pattern: "Please enter valid {{ field }}"
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 150
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "physicalDisability",
                                            placeholder: "Enter here",
                                            type: "textfield",
                                            input: true,
                                            label: "Physical Disability (if any)",
                                            errors: {
                                                pattern: "Please enter valid {{ field }}"
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 150
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "height",
                                            type: "number",
                                            input: true,
                                            label: "Height (in Cms)",
                                            placeholder: "Enter here",
                                            validate: {
                                                min: 150,
                                                max: 250
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "weight",
                                            type: "number",
                                            input: true,
                                            label: "Weight (in Kgs)",
                                            placeholder: "Enter here",
                                            validate: {
                                                min: 45,
                                                max: 150
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "powerOfLeftEye",
                                            type: "textfield",
                                            placeholder: "Enter here",
                                            input: true,
                                            label: "Power of Eye glass (Left Eye)",
                                            errors: {
                                                pattern: "Please enter valid {{ field }}"
                                            },
                                            validate: {
                                                pattern: "^[-+]?[0-9]+(\\.[0-9]{1,2})?$"
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "powerOfRightEye",
                                            type: "textfield",
                                            placeholder: "Enter here",
                                            input: true,
                                            label: "Power of Eye glass (Right Eye)",
                                            errors: {
                                                pattern: "Please enter valid {{ field }}"
                                            },
                                            validate: {
                                                pattern: "^[-+]?[0-9]+(\\.[0-9]{1,2})?$"
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Identification Mark",
                                            key: "identificationMark1",
                                            type: "textfield",
                                            placeholder: "Enter here",
                                            input: true,
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            tableView: true
                                        },
                                        {
                                            label: "Identification Mark",
                                            hideLabel: true,
                                            key: "identificationMark2",
                                            type: "textfield",
                                            placeholder: "Enter here",
                                            input: true,
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            tableView: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "healthDetailsColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    tableView: false
                }
            },
            dependentDetails: {
                title: "Dependent Details",
                icon: "users",
                theme: "primary",
                schema: {
                    title: "Dependent Details",
                    theme: "primary",
                    collapsible: true,
                    key: "dependentDetailsPanel",
                    type: "panel",
                    label: "Panel",
                    collapsed: false,
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Dependent Details",
                            reorder: false,
                            addAnother: "Add Dependent",
                            addAnotherPosition: "bottom",
                            layoutFixed: false,
                            enableRowGroups: false,
                            customClass: "overflow-hidden",
                            initEmpty: false,
                            hideLabel: true,
                            tableView: false,
                            key: "dependentDetails",
                            type: "datagrid",
                            input: false,
                            theme: "primary",
                            title: "Dependent Details",
                            components: [
                                {
                                    label: "Columns",
                                    columns: [
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 4,
                                            offset: 0,
                                            components: [
                                                {
                                                    key: "depententTitle",
                                                    data: {
                                                        values: [
                                                            {
                                                                label: "Mr.",
                                                                value: "Mr."
                                                            },
                                                            {
                                                                label: "Mrs.",
                                                                value: "Mrs."
                                                            },
                                                            {
                                                                label: "Ms.",
                                                                value: "Ms."
                                                            },
                                                            {
                                                                label: "Late.",
                                                                value: "Late."
                                                            }
                                                        ]
                                                    },
                                                    type: "select",
                                                    input: true,
                                                    label: "Title",
                                                    widget: "choicesjs",
                                                    errors: {
                                                        required: "{{ field }} is required."
                                                    },
                                                    validate: {
                                                        required: true
                                                    },
                                                    tableView: true,
                                                    placeholder: "--Select--",
                                                    searchEnabled: false
                                                }
                                            ],
                                            currentWidth: 4
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 4,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Name",
                                                    placeholder: "Enter here",
                                                    validate: {
                                                        required: true,
                                                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                        maxLength: 150
                                                    },
                                                    errors: {
                                                        required: "{{ field }} is required.",
                                                        pattern: "Please enter valid {{ field }}"
                                                    },
                                                    key: "dependentName",
                                                    type: "textfield",
                                                    input: true,
                                                    tableView: true
                                                }
                                            ],
                                            currentWidth: 4
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 4,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Date Of Birth",
                                                    allowInput: false,
                                                    format: "dd-MMM-yyyy",
                                                    datePicker: {
                                                        disableWeekends: false,
                                                        disableWeekdays: false
                                                    },
                                                    enableTime: false,
                                                    timePicker: {
                                                        showMeridian: false
                                                    },
                                                    clearOnHide: false,
                                                    validate: {
                                                        required: true
                                                    },
                                                    enableMinDateInput: false,
                                                    enableMaxDateInput: false,
                                                    errors: {
                                                        required: "{{ field }} is required."
                                                    },
                                                    key: "dependentDateOfBirth",
                                                    type: "datetime",
                                                    input: false,
                                                    tableView: false,
                                                    template: "<div><label>Date of Birth</label><input type='date' ref='input' readonly class='form-control' required></div>",
                                                    widget: {
                                                        type: "calendar",
                                                        displayInTimezone: "viewer",
                                                        locale: "en",
                                                        useLocaleSettings: false,
                                                        allowInput: false,
                                                        mode: "single",
                                                        enableTime: false,
                                                        noCalendar: false,
                                                        format: "dd-MMM-yyyy",
                                                        hourIncrement: 1,
                                                        minuteIncrement: 1,
                                                        time_24hr: true,
                                                        minDate: null,
                                                        disableWeekends: false,
                                                        disableWeekdays: false,
                                                        maxDate: null
                                                    }
                                                }
                                            ],
                                            currentWidth: 4
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 6,
                                            offset: 0,
                                            components: [
                                                {
                                                    key: "dependentRelationShips",
                                                    data: {
                                                        values: [
                                                            {
                                                                label: "Father",
                                                                value: "Father"
                                                            },
                                                            {
                                                                label: "Mother",
                                                                value: "Mother"
                                                            },
                                                            {
                                                                label: "Brother",
                                                                value: "Brother"
                                                            },
                                                            {
                                                                label: "Sister",
                                                                value: "Sister"
                                                            },
                                                            {
                                                                label: "Spouse",
                                                                value: "Spouse"
                                                            },
                                                            {
                                                                label: "Daughter",
                                                                value: "Daughter"
                                                            },
                                                            {
                                                                label: "Son",
                                                                value: "Son"
                                                            }
                                                        ]
                                                    },
                                                    type: "select",
                                                    input: true,
                                                    label: "Relationship",
                                                    widget: "choicesjs",
                                                    errors: {
                                                        required: "{{ field }} is required."
                                                    },
                                                    validate: {
                                                        required: true
                                                    },
                                                    tableView: true,
                                                    placeholder: "--Select--",
                                                    searchEnabled: false
                                                }
                                            ],
                                            currentWidth: 6
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 6,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Occupucation",
                                                    placeholder: "--Select--",
                                                    data: {
                                                        values: [
                                                            {
                                                                label: "Agriculture",
                                                                value: "Agriculture"
                                                            },
                                                            {
                                                                label: "Business",
                                                                value: "Business"
                                                            },
                                                            {
                                                                label: "Defence Staff",
                                                                value: "Defence Staff"
                                                            },
                                                            {
                                                                label: "Student",
                                                                value: "Student"
                                                            },
                                                            {
                                                                label: "Retired",
                                                                value: "Retired"
                                                            },
                                                            {
                                                                label: "Housewife",
                                                                value: "Housewife"
                                                            },
                                                            {
                                                                label: "Government Employee",
                                                                value: "Government Employee"
                                                            },
                                                            {
                                                                label: "Professional",
                                                                value: "Professional"
                                                            },
                                                            {
                                                                label: "Self Employed",
                                                                value: "Self Employed"
                                                            },
                                                            {
                                                                label: "Salaried",
                                                                value: "Salaried"
                                                            },
                                                            {
                                                                label: "Others",
                                                                value: "Others"
                                                            }
                                                        ]
                                                    },
                                                    searchEnabled: false,
                                                    errors: {
                                                        required: "{{ field }} is required."
                                                    },
                                                    key: "dependentOccupation",
                                                    type: "select",
                                                    input: true,
                                                    widget: "choicesjs",
                                                    tableView: true
                                                }
                                            ],
                                            currentWidth: 6
                                        },
                                        {
                                            components: [
                                                {
                                                    label: "Differently Abled",
                                                    data: {
                                                        values: [
                                                            {
                                                                label: "Yes",
                                                                value: "Yes"
                                                            },
                                                            {
                                                                label: "No",
                                                                value: "No"
                                                            }
                                                        ]
                                                    },
                                                    key: "differentlyAbled",
                                                    type: "select",
                                                    input: true,
                                                    tableView: true,
                                                    defaultValue: "No"
                                                }
                                            ],
                                            size: "md",
                                            width: 6,
                                            offset: 0,
                                            push: 0,
                                            pull: 0,
                                            currentWidth: 6
                                        },
                                        {
                                            components: [
                                                {
                                                    label: "Status",
                                                    data: {
                                                        values: [
                                                            {
                                                                label: "Active",
                                                                value: "Active"
                                                            },
                                                            {
                                                                label: "Inactive",
                                                                value: "Inactive"
                                                            }
                                                        ]
                                                    },
                                                    key: "status",
                                                    type: "select",
                                                    input: true,
                                                    tableView: true,
                                                    defaultValue: "Active"
                                                }
                                            ],
                                            size: "md",
                                            width: 6,
                                            offset: 0,
                                            push: 0,
                                            pull: 0,
                                            currentWidth: 6
                                        },
                                        {
                                            components: [
                                                {
                                                    label: "Is Dependent",
                                                    data: {
                                                        values: [
                                                            {
                                                                label: "Yes",
                                                                value: "Yes"
                                                            },
                                                            {
                                                                label: "No",
                                                                value: "No"
                                                            }
                                                        ]
                                                    },
                                                    key: "isDependent",
                                                    type: "select",
                                                    input: true,
                                                    tableView: true,
                                                    defaultValue: "No"
                                                }
                                            ],
                                            size: "md",
                                            width: 6,
                                            offset: 0,
                                            push: 0,
                                            pull: 0,
                                            currentWidth: 6
                                        }
                                    ],
                                    autoAdjust: true,
                                    hideLabel: true,
                                    key: "dependentDetailsColumns",
                                    type: "columns",
                                    input: false,
                                    tableView: false
                                }
                            ]
                        }
                    ]
                }
            },
            joiningDocumentsUpload: {
                title: "Joining Documents Upload",
                icon: "file",
                schema: {
                    title: "Joining Documents Upload",
                    theme: "primary",
                    collapsible: true,
                    key: "joiningDocumentsUploadPanel",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "HTML",
                                            className: "text-primary float-right",
                                            attrs: [
                                                {
                                                    attr: "",
                                                    value: ""
                                                }
                                            ],
                                            content: "Accepted Formats (.pdf, .jpg, .jpeg) (Maximum file size 2MB)",
                                            refreshOnChange: false,
                                            key: "html",
                                            type: "htmlelement",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "HTML",
                                                            tag: "h6",
                                                            className: "mt-5",
                                                            attrs: [
                                                                {
                                                                    attr: "",
                                                                    value: ""
                                                                }
                                                            ],
                                                            content: "Aadhar Card <span class=\"text-danger\">*</span>",
                                                            refreshOnChange: false,
                                                            key: "html1",
                                                            type: "htmlelement",
                                                            input: false,
                                                            tableView: false
                                                        }
                                                    ],
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Document Description",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            validate: {
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                                maxLength: 150
                                                            },
                                                            errors: {
                                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                            },
                                                            key: "documentDescriptionAadharCard",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Upload Aadhar Card",
                                                            dir: "aadhar-card",
                                                            url: `storage/azure?_token={{csrfToken}}&exts=pdf`,
                                                            hideLabel: true,
                                                            tableView: false,
                                                            webcam: false,
                                                            storage: "url",
                                                            fileTypes: [
                                                                {
                                                                    label: "PDF",
                                                                    value: "pdf"
                                                                }
                                                            ],
                                                            fileMaxSize: "4000KB",
                                                            fileMinSize: "2KB",
                                                            validate: {
                                                                required: true
                                                            },
                                                            key: "uploadAadharCard",
                                                            type: "file",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                // {
                                                //     components: [
                                                //         {
                                                //             label: "View",
                                                //             showValidations: false,
                                                //             theme: "info",
                                                //             customClass: "text-center mt-3",
                                                //             tableView: false,
                                                //             key: "viewAadharCard",
                                                //             type: "button",
                                                //             saveOnEnter: false,
                                                //             input: true
                                                //         }
                                                //     ],
                                                //     size: "md",
                                                //     width: 2,
                                                //     offset: 0,
                                                //     push: 0,
                                                //     pull: 0,
                                                //     currentWidth: 2
                                                // },
                                                {
                                                    components: [
                                                        {
                                                            label: "HTML",
                                                            tag: "h6",
                                                            className: "mt-5",
                                                            attrs: [
                                                                {
                                                                    attr: "",
                                                                    value: ""
                                                                }
                                                            ],
                                                            content: "PAN Card/PAN Application <span class=\"text-danger\">*</span>",
                                                            refreshOnChange: false,
                                                            key: "html2",
                                                            type: "htmlelement",
                                                            input: false,
                                                            tableView: false
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Document Description",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            validate: {
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                                maxLength: 150
                                                            },
                                                            errors: {
                                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                            },
                                                            key: "documentDescriptionPANCard",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Upload PAN Card/PAN Application",
                                                            dir: "pan-card",
                                                            url: `storage/azure?_token={{csrfToken}}&exts=pdf`,
                                                            hideLabel: true,
                                                            tableView: false,
                                                            webcam: false,
                                                            storage: "url",
                                                            fileTypes: [
                                                                {
                                                                    label: "PDF",
                                                                    value: "pdf"
                                                                }
                                                            ],
                                                            fileMaxSize: "4000KB",
                                                            fileMinSize: "2KB",
                                                            validate: {
                                                                required: true
                                                            },
                                                            key: "uploadPANCard",
                                                            type: "file",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                // {
                                                //     components: [
                                                //         {
                                                //             label: "View",
                                                //             showValidations: false,
                                                //             theme: "info",
                                                //             customClass: "text-center mt-3",
                                                //             tableView: false,
                                                //             key: "viewPancard",
                                                //             type: "button",
                                                //             saveOnEnter: false,
                                                //             input: true
                                                //         }
                                                //     ],
                                                //     size: "md",
                                                //     width: 2,
                                                //     offset: 0,
                                                //     push: 0,
                                                //     pull: 0,
                                                //     currentWidth: 2
                                                // },
                                                {
                                                    components: [
                                                        {
                                                            label: "HTML",
                                                            tag: "h6",
                                                            className: "mt-5",
                                                            attrs: [
                                                                {
                                                                    attr: "",
                                                                    value: ""
                                                                }
                                                            ],
                                                            content: "Passport Size Photo <span class=\"text-danger\">*</span>",
                                                            refreshOnChange: false,
                                                            key: "html3",
                                                            type: "htmlelement",
                                                            input: false,
                                                            tableView: false
                                                        },
                                                        {
                                                            components: [
                                                                {
                                                                    label: "HTML",
                                                                    className: "text-danger float-left",
                                                                    attrs: [
                                                                        {
                                                                            attr: "",
                                                                            value: ""
                                                                        }
                                                                    ],
                                                                    content: "Note: Upload passport size photo with light (or) plain background.",
                                                                    refreshOnChange: false,
                                                                    key: "html4",
                                                                    type: "htmlelement",
                                                                    input: false,
                                                                    tableView: false
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Document Description",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            validate: {
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                                maxLength: 150
                                                            },
                                                            errors: {
                                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                            },
                                                            key: "documentDescriptionPassportSizePhoto",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Upload Passport Size Photo (JPG/JPEG Format only)",
                                                            dir: "passport-size-photo",
                                                            url: `storage/azure?_token={{csrfToken}}&exts=jpeg,jpg&dms=139*179&checkFaceDetection=true`,
                                                            hideLabel: true,
                                                            tableView: false,
                                                            webcam: false,
                                                            storage: "url",
                                                            fileTypes: [
                                                                {
                                                                    label: "JPG",
                                                                    value: "jpg"
                                                                },
                                                                {
                                                                    label: "JPEG",
                                                                    value: "jpeg"
                                                                }
                                                            ],
                                                            imageSize: "139",
                                                            fileMaxSize: "200KB",
                                                            fileMinSize: "5KB",
                                                            validate: {
                                                                required: true
                                                            },
                                                            key: "uploadPassportSizePhoto",
                                                            type: "file",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                // {
                                                //     components: [
                                                //         {
                                                //             label: "View",
                                                //             showValidations: false,
                                                //             theme: "info",
                                                //             customClass: "text-center mt-3",
                                                //             tableView: false,
                                                //             key: "viewPassportSizePhoto",
                                                //             type: "button",
                                                //             saveOnEnter: false,
                                                //             input: true
                                                //         }
                                                //     ],
                                                //     size: "md",
                                                //     width: 2,
                                                //     offset: 0,
                                                //     push: 0,
                                                //     pull: 0,
                                                //     currentWidth: 2
                                                // }
                                            ],
                                            key: "joiningDocumentsUploadColumns1",
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "joiningDocumentsUploadColumns2",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            educationDocumentsUpload: {
                title: "Education Documents Upload",
                icon: "book",
                schema: {
                    title: "Education Documents Upload",
                    theme: "primary",
                    collapsible: true,
                    key: "educationDocumentsUpload",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "HTML",
                                            className: "text-primary float-right",
                                            attrs: [
                                                {
                                                    attr: "",
                                                    value: ""
                                                }
                                            ],
                                            content: "Accepted Formats (.pdf) (Maximum file size 2MB)",
                                            refreshOnChange: false,
                                            key: "html7",
                                            type: "htmlelement",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "educationDocumentsUploadColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        },
                        {
                            title: "Certificate Uploads",
                            collapsible: true,
                            key: "certificateUploadsPanel",
                            type: "panel",
                            label: "Panel",
                            input: false,
                            tableView: false,
                            collapsed: true,
                            components: [
                                {
                                    label: "HTML",
                                    className: "text-danger",
                                    attrs: [
                                        {
                                            attr: "",
                                            value: ""
                                        }
                                    ],
                                    content: "(If you don't have certificates/marksheets for all/some of the semesters, you can provide the reason in the next screen later.)",
                                    refreshOnChange: false,
                                    key: "html",
                                    type: "htmlelement",
                                    input: false,
                                    tableView: false
                                },
                                {
                                    label: "Certificate Uploads",
                                    reorder: false,
                                    addAnother: "Add Semester",
                                    addAnotherPosition: "bottom",
                                    layoutFixed: false,
                                    enableRowGroups: false,
                                    initEmpty: false,
                                    hideLabel: true,
                                    tableView: false,
                                    key: "certificateUploads2",
                                    type: "datagrid",
                                    input: false,
                                    theme: "primary",
                                    title: "Certificate Uploads",
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    pull: 0,
                                                    push: 0,
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    components: [
                                                        {
                                                            label: "Enter Semester Number",
                                                            placeholder: "Enter here",
                                                            validate: {
                                                                required: true
                                                            },
                                                            key: "enterSemesterNumber",
                                                            type: "textfield",
                                                            input: true,
                                                            tableView: true
                                                        }
                                                    ],
                                                    currentWidth: 3
                                                },
                                                {
                                                    pull: 0,
                                                    push: 0,
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    components: [
                                                        {
                                                            label: "Document Description",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            validate: {
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                                maxLength: 150
                                                            },
                                                            errors: {
                                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                            },
                                                            key: "documentDescriptionAadharCard2",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    currentWidth: 3
                                                },
                                                {
                                                    pull: 0,
                                                    push: 0,
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    components: [
                                                        {
                                                            label: "Upload Semester",
                                                            hideLabel: true,
                                                            tableView: false,
                                                            storage: "url",
                                                            dir: "semester",
                                                            webcam: false,
                                                            validate: {
                                                                required: true
                                                            },
                                                            fileTypes: [
                                                                {
                                                                    label: "PDF",
                                                                    value: "pdf"
                                                                }
                                                            ],
                                                            fileMinSize: "2KB",
                                                            fileMaxSize: "4000KB",
                                                            key: "uploadSemester",
                                                            type: "file",
                                                            url: "storage/azure?_token={{csrfToken}}&exts=pdf",
                                                            input: true
                                                        }
                                                    ],
                                                    currentWidth: 4
                                                },
                                                // {
                                                //     pull: 0,
                                                //     push: 0,
                                                //     size: "md",
                                                //     width: 2,
                                                //     offset: 0,
                                                //     components: [
                                                //         {
                                                //             label: "View",
                                                //             showValidations: false,
                                                //             theme: "info",
                                                //             customClass: "text-center mt-3",
                                                //             disabled: true,
                                                //             tableView: false,
                                                //             key: "viewSemester",
                                                //             type: "button",
                                                //             saveOnEnter: false,
                                                //             input: true
                                                //         }
                                                //     ],
                                                //     currentWidth: 2
                                                // }
                                            ],
                                            autoAdjust: true,
                                            hideLabel: true,
                                            key: "certificateUploadsColumns",
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            transferCertificateUpload: {
                title: "Transfer Certificate Upload",
                icon: "certificate",
                schema: {
                    title: "Transfer/Conduct Certificate Upload",
                    theme: "primary",
                    collapsible: true,
                    key: "transferConductCertificateUpload",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "HTML",
                                            className: "text-primary float-right",
                                            attrs: [
                                                {
                                                    attr: "",
                                                    value: ""
                                                }
                                            ],
                                            content: "Accepted Formats (.pdf) (Maximum file size 2MB)",
                                            refreshOnChange: false,
                                            key: "html5",
                                            type: "htmlelement",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "HTML",
                                                            tag: "h6",
                                                            className: "mt-5",
                                                            attrs: [
                                                                {
                                                                    attr: "",
                                                                    value: ""
                                                                }
                                                            ],
                                                            content: "Transfer Certificate",
                                                            refreshOnChange: false,
                                                            key: "html6",
                                                            type: "htmlelement",
                                                            input: false,
                                                            tableView: false
                                                        }
                                                    ],
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Document Description",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            validate: {
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                                maxLength: 150
                                                            },
                                                            errors: {
                                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                            },
                                                            key: "documentDescriptionTransferCertificate",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Upload Transfer Certificate",
                                                            hideLabel: true,
                                                            tableView: false,
                                                            storage: "url",
                                                            dir: "transfer-certificate",
                                                            webcam: false,
                                                            fileTypes: [
                                                                {
                                                                    label: "PDF",
                                                                    value: "pdf"
                                                                }
                                                            ],
                                                            fileMinSize: "2KB",
                                                            fileMaxSize: "4000KB",
                                                            key: "uploadTransferCertificate",
                                                            type: "file",
                                                            url: "storage/azure?_token={{csrfToken}}&exts=pdf",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                // {
                                                //     components: [
                                                //         {
                                                //             label: "View",
                                                //             showValidations: false,
                                                //             theme: "info",
                                                //             customClass: "text-center mt-3",
                                                //             disabled: true,
                                                //             tableView: false,
                                                //             key: "viewTransferCertificate",
                                                //             type: "button",
                                                //             saveOnEnter: false,
                                                //             input: true
                                                //         }
                                                //     ],
                                                //     size: "md",
                                                //     width: 2,
                                                //     offset: 0,
                                                //     push: 0,
                                                //     pull: 0,
                                                //     currentWidth: 2
                                                // }
                                            ],
                                            key: "columns3",
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "columns2",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            resumeUpload: {
                title: "Resume Upload",
                icon: "upload",
                schema: {
                    title: "Resume Upload",
                    theme: "primary",
                    collapsible: true,
                    key: "resumeUpload",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "HTML",
                                            className: "text-primary float-right",
                                            attrs: [
                                                {
                                                    attr: "",
                                                    value: ""
                                                }
                                            ],
                                            content: "Accepted Formats (.pdf) (Maximum file size 2MB)",
                                            refreshOnChange: false,
                                            key: "html5",
                                            type: "htmlelement",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "HTML",
                                                            tag: "h6",
                                                            className: "mt-5",
                                                            attrs: [
                                                                {
                                                                    attr: "",
                                                                    value: ""
                                                                }
                                                            ],
                                                            content: "Resume",
                                                            refreshOnChange: false,
                                                            key: "html6",
                                                            type: "htmlelement",
                                                            input: false,
                                                            tableView: false
                                                        }
                                                    ],
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Document Description",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            validate: {
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                                maxLength: 150
                                                            },
                                                            errors: {
                                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                            },
                                                            key: "documentDescriptionResumeUpload",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Upload Resume",
                                                            hideLabel: true,
                                                            tableView: false,
                                                            storage: "url",
                                                            dir: "joining-resume",
                                                            webcam: false,
                                                            fileTypes: [
                                                                {
                                                                    label: "PDF",
                                                                    value: "pdf"
                                                                }
                                                            ],
                                                            fileMinSize: "2KB",
                                                            fileMaxSize: "4000KB",
                                                            key: "uploadResume",
                                                            type: "file",
                                                            url: "storage/azure?_token={{csrfToken}}&exts=pdf",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                // {
                                                //     components: [
                                                //         {
                                                //             label: "View",
                                                //             showValidations: false,
                                                //             theme: "info",
                                                //             customClass: "text-center mt-3",
                                                //             disabled: true,
                                                //             tableView: false,
                                                //             key: "viewResume",
                                                //             type: "button",
                                                //             saveOnEnter: false,
                                                //             input: true
                                                //         }
                                                //     ],
                                                //     size: "md",
                                                //     width: 2,
                                                //     offset: 0,
                                                //     push: 0,
                                                //     pull: 0,
                                                //     currentWidth: 2
                                                // }
                                            ],
                                            key: "columns3",
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "columns2",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            bankDetails: {
                title: "Bank Details",
                icon: "university",
                schema: {
                    title: "Bank Details",
                    theme: "primary",
                    collapsible: true,
                    key: "bankDetails",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Bank Name",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                            },
                                            key: "bankName",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    width: 4,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 4
                                },
                                {
                                    components: [
                                        {
                                            label: "Bank Account No.",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                pattern: "^\\d{9}$"
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "The input contains invalid characters. Only numerics are allowed."
                                            },
                                            key: "bankAccountNo",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    width: 4,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 4
                                },
                                {
                                    components: [
                                        {
                                            label: "Bank IFSC Code",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            case: "uppercase",
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Z]{4}0[A-Z0-9]{6}$"
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "The input contains invalid characters. Only alphanumerics are allowed."
                                            },
                                            key: "bankIfscCode",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 4,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 4
                                },
                                {
                                    components: [
                                        {
                                            label: "Branch Name",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                            },
                                            key: "branchName",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 3,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 3
                                },
                                {
                                    components: [
                                        {
                                            label: "Document Description",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                            },
                                            key: "documentDescription",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 3,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 3
                                },
                                {
                                    components: [
                                        {
                                            label: "Upload Bank Document",
                                            hideLabel: true,
                                            tableView: false,
                                            storage: "url",
                                            dir: "bank-document",
                                            webcam: false,
                                            fileTypes: [
                                                {
                                                    label: "PDF",
                                                    value: "pdf"
                                                }
                                            ],
                                            fileMinSize: "2KB",
                                            fileMaxSize: "4000KB",
                                            key: "uploadBankDocument",
                                            type: "file",
                                            url: "storage/azure?_token={{csrfToken}}&exts=pdf",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 4,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 4
                                },
                                // {
                                //     components: [
                                //         {
                                //             label: "View",
                                //             showValidations: false,
                                //             theme: "info",
                                //             customClass: "text-center mt-3",
                                //             disabled: true,
                                //             tableView: false,
                                //             key: "viewBankDetail",
                                //             type: "button",
                                //             input: true,
                                //             saveOnEnter: false
                                //         }
                                //     ],
                                //     size: "md",
                                //     width: 2,
                                //     offset: 0,
                                //     push: 0,
                                //     pull: 0,
                                //     currentWidth: 2
                                // }
                            ],
                            autoAdjust: true,
                            key: "bankDetailsColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    collapsed: false
                }
            },
            certificateUploads: {
                title: "Certificate Uploads",
                icon: "file-alt",
                schema: {
                    title: "Certificate Uploads",
                    theme: "primary",
                    collapsible: true,
                    key: "certificateUploads",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "HTML",
                                            className: "text-primary float-right",
                                            attrs: [
                                                {
                                                    attr: "",
                                                    value: ""
                                                }
                                            ],
                                            content: "Accepted Formats (.pdf) (Maximum file size 2MB)",
                                            refreshOnChange: false,
                                            key: "html7",
                                            type: "htmlelement",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "certificateUploadsColumns1",
                            type: "columns",
                            input: false,
                            tableView: false
                        },
                        {
                            label: "Certificate Uploads",
                            reorder: false,
                            addAnother: "Add Certificate",
                            addAnotherPosition: "bottom",
                            layoutFixed: false,
                            enableRowGroups: false,
                            initEmpty: false,
                            hideLabel: true,
                            tableView: false,
                            key: "certificateUploadsGrid",
                            type: "datagrid",
                            input: false,
                            theme: "primary",
                            title: "Certificate Details",
                            components: [
                                {
                                    label: "Columns",
                                    columns: [
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 3,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Certificate Name",
                                                    placeholder: "Enter here",
                                                    tableView: true,
                                                    key: "certificateName",
                                                    type: "textfield",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 3
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 3,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Document Description",
                                                    placeholder: "Enter here",
                                                    tableView: true,
                                                    validate: {
                                                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                        maxLength: 150
                                                    },
                                                    errors: {
                                                        pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                    },
                                                    key: "documentDescriptionAadharCard2",
                                                    type: "textfield",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 3
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 4,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Upload Cerificate",
                                                    hideLabel: true,
                                                    tableView: false,
                                                    storage: "url",
                                                    dir: "uplaod-certificate",
                                                    webcam: false,
                                                    fileTypes: [
                                                        {
                                                            label: "PDF",
                                                            value: "pdf"
                                                        }
                                                    ],
                                                    fileMinSize: "2KB",
                                                    fileMaxSize: "4000KB",
                                                    key: "uploadCerificate",
                                                    type: "file",
                                                    url: "storage/azure?_token={{csrfToken}}&exts=pdf",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 4
                                        },
                                        // {
                                        //     pull: 0,
                                        //     push: 0,
                                        //     size: "md",
                                        //     width: 2,
                                        //     offset: 0,
                                        //     components: [
                                        //         {
                                        //             label: "View",
                                        //             showValidations: false,
                                        //             theme: "info",
                                        //             customClass: "text-center mt-3",
                                        //             disabled: true,
                                        //             tableView: false,
                                        //             key: "viewCertificate",
                                        //             type: "button",
                                        //             saveOnEnter: false,
                                        //             input: true
                                        //         }
                                        //     ],
                                        //     currentWidth: 2
                                        // }
                                    ],
                                    autoAdjust: true,
                                    hideLabel: true,
                                    key: "certificateUploadsColumns2",
                                    type: "columns",
                                    input: false,
                                    tableView: false
                                }
                            ]
                        }
                    ]
                }
            },
            otherUploads: {
                title: "Other Uploads",
                icon: "upload",
                schema: {
                    title: "Other Uploads",
                    theme: "primary",
                    collapsible: true,
                    key: "otherUploads",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "HTML",
                                            className: "text-primary float-right",
                                            attrs: [
                                                {
                                                    attr: "",
                                                    value: ""
                                                }
                                            ],
                                            content: "Accepted Formats (.pdf) (Maximum file size 2MB)",
                                            refreshOnChange: false,
                                            key: "html7",
                                            type: "htmlelement",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "otherUploadsColumns1",
                            type: "columns",
                            input: false,
                            tableView: false
                        },
                        {
                            label: "Other Uploads",
                            reorder: false,
                            addAnother: "Add Document",
                            addAnotherPosition: "bottom",
                            layoutFixed: false,
                            enableRowGroups: false,
                            initEmpty: false,
                            hideLabel: true,
                            tableView: false,
                            key: "otherUploads",
                            type: "datagrid",
                            input: false,
                            theme: "primary",
                            title: "Other Document Details",
                            components: [
                                {
                                    label: "Columns",
                                    columns: [
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 3,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Document Name",
                                                    placeholder: "Enter here",
                                                    tableView: true,
                                                    key: "documentName",
                                                    type: "textfield",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 3
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 3,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Document Description",
                                                    placeholder: "Enter here",
                                                    tableView: true,
                                                    validate: {
                                                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                        maxLength: 150
                                                    },
                                                    errors: {
                                                        pattern: "The input contains invalid characters. Only alphabets & spaces are allowed."
                                                    },
                                                    key: "documentDescriptionAadharCard2",
                                                    type: "textfield",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 3
                                        },
                                        {
                                            pull: 0,
                                            push: 0,
                                            size: "md",
                                            width: 4,
                                            offset: 0,
                                            components: [
                                                {
                                                    label: "Upload Document",
                                                    hideLabel: true,
                                                    tableView: false,
                                                    storage: "url",
                                                    dir: "upload-document",
                                                    webcam: false,
                                                    fileTypes: [
                                                        {
                                                            label: "PDF",
                                                            value: "pdf"
                                                        }
                                                    ],
                                                    fileMinSize: "2KB",
                                                    fileMaxSize: "4000KB",
                                                    key: "uploadDocument",
                                                    type: "file",
                                                    url: "storage/azure?_token={{csrfToken}}&exts=pdf",
                                                    input: true
                                                }
                                            ],
                                            currentWidth: 4
                                        },
                                        // {
                                        //     pull: 0,
                                        //     push: 0,
                                        //     size: "md",
                                        //     width: 2,
                                        //     offset: 0,
                                        //     components: [
                                        //         {
                                        //             label: "View",
                                        //             showValidations: false,
                                        //             theme: "info",
                                        //             customClass: "text-center mt-3",
                                        //             disabled: true,
                                        //             tableView: false,
                                        //             key: "viewDocument",
                                        //             type: "button",
                                        //             saveOnEnter: false,
                                        //             input: true
                                        //         }
                                        //     ],
                                        //     currentWidth: 2
                                        // }
                                    ],
                                    autoAdjust: true,
                                    hideLabel: true,
                                    key: "otherUploadsColumns2",
                                    type: "columns",
                                    input: false,
                                    tableView: false
                                }
                            ]
                        }
                    ]
                }
            }
        }
    },
    personalFields: {
        title: "Personal",
        weight: 2,
        components: {
            firstName: {
                title: "First Name",
                icon: "id-badge",
                schema: {
                    label: "First Name",
                    type: "textfield",
                    key: "firstName",
                    input: true,
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters and spaces."
                    },
                    validate: {
                        required: true,
                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                    }
                }
            },
            middleName: {
                title: "Middle Name",
                icon: "id-badge",
                schema: {
                    label: "Middle Name",
                    type: "textfield",
                    key: "middleName",
                    input: true,
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters and spaces."
                    },
                    validate: {
                        required: true,
                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                    }
                }
            },
            lastName: {
                title: "Last Name",
                icon: "id-badge",
                schema: {
                    label: "Last Name",
                    type: "textfield",
                    key: "lastName",
                    input: true,
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters and spaces."
                    },
                    validate: {
                        required: true,
                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                    }
                }
            },
            surname: {
                title: "Surname",
                icon: "id-badge",
                schema: {
                    label: "Surname",
                    type: "textfield",
                    key: "surName",
                    input: true,
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "Invalid name format as per Aadhaar guidelines. Please use only alphabetic characters and spaces."
                    },
                    validate: {
                        required: true,
                        pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                    }
                }
            },
            emailAddress: {
                title: "Email Address",
                icon: "at",
                schema: {
                    key: "emailAddress",
                    type: "email",
                    input: true,
                    label: "Email Address",
                    errors: {
                        custom: "{{ field }} is already exist.",
                        required: "{{ field }} is required."
                    },
                    unique: true,
                    validate: {
                        required: true
                    }
                }
            },
            mobileNumber: {
                title: "Mobile Phone",
                icon: "phone-square",
                schema: {
                    label: "Mobile Phone",
                    type: "textfield",
                    key: "mobilePhone",
                    prefix: "+91",
                    input: true,
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "Please enter a 10-digit mobile number starting with 6, 7, 8, or 9."
                    },
                    validate: {
                        required: true,
                        pattern: "^[6-9]\\d{9}$"
                    },
                    inputMask: "9999999999",
                    displayMask: "9999999999"
                }
            },
            emergencyContactNumber: {
                title: "Emergency Contact Number",
                icon: "phone-square",
                schema: {
                    label: "Emergency Contact Number",
                    type: "textfield",
                    key: "emergencyContactNumber",
                    prefix: "+91",
                    input: true,
                    errors: {
                        pattern: "Please enter a 10-digit mobile number starting with 6, 7, 8, or 9."
                    },
                    validate: {
                        pattern: "^[6-9]\\d{9}$"
                    },
                    inputMask: "9999999999",
                    displayMask: "9999999999"
                }
            },
            gender: {
                title: "Gender",
                input: true,
                icon: "venus-mars",
                schema: {
                    label: "Gender",
                    type: "select",
                    key: "gender",
                    input: true,
                    placeholder: "--select--",
                    errors: {
                        required: "{{ field }} is required."
                    },
                    validate: {
                        required: true
                    },
                    data: {
                        values: [
                            { label: 'Male', value: 'Male' },
                            { label: 'Female', value: 'Female' },
                            { label: 'Others', value: 'Others' }
                        ]
                    }
                }
            },
            DOB: {
                title: "Date Of Birth",
                icon: "calendar-alt",
                format: "dd-MMM-yyyy",
                schema: {
                    type: "datetime",
                    key: "dateOfBirth",
                    format: "dd-MMM-yyyy",
                    enableTime: false,
                    allowInput: false,
                    timePicker: {
                        showMeridian: false
                    },
                    input: false,
                    label: "Date Of Birth",
                    tableView: false,
                    clearOnHide: false,
                    template: "<div><label>Date of Birth</label><input type='date' ref='input' readonly class='form-control col-md-6' required></div>",
                    errors: {
                        required: "{{ field }} is required."
                    },
                    validate: {
                        required: true
                    }
                }
            },
            aadhaarNumber: {
                title: "Aadhaar Number",
                icon: "id-card",
                schema: {
                    label: "Aadhaar Number",
                    type: "textfield",
                    key: "aadhaarNumber",
                    inputMask: "9999 9999 9999",
                    errors: {
                        required: '{{ field }} is mandatory'
                    },
                    validate: {
                        required: true
                    }
                }
            },
            panCardNumber: {
                title: "Pan Card Number",
                icon: "address-card",
                schema: {
                    label: "Pan Card Number",
                    type: "textfield",
                    key: "panCardNumber",
                    case: "uppercase",
                    inputMask: "AAAAA9999A",
                    errors: {
                        pattern: "Please enter a valid PAN card number"
                    },
                    validate: {
                        pattern: "^[A-Z]{5}[0-9]{4}[A-Z]$"
                    }
                }
            },
            drivingLicenseNumber: {
                title: "Driving License Number",
                icon: "credit-card",
                schema: {
                    label: "Driving License Number",
                    case: "uppercase",
                    type: "textfield",
                    key: "drivingLicenseNumber",
                    inputMask: "AA-99-9999-99999",
                    errors: {
                        pattern: "Please enter a valid Driving License number"
                    },
                    validate: {
                        pattern: "^[A-Za-z]{2}-\\d{2}-\\d{4}-\\d{5}$"
                    }
                }
            },
            passportNumber: {
                title: "Passport Number",
                icon: "globe",
                schema: {
                    label: "Passport Number",
                    type: "textfield",
                    key: "passportNumber",
                    case: "uppercase",
                    inputMask: "AA999999",
                    errors: {
                        mask: "Please enter a valid Passport number"
                    }
                }
            },
            maritalStatus: {
                title: "<i class='fas fa-gem'></i> Marital Status",
                input: true,
                schema: {
                    label: "Marital Status",
                    type: "select",
                    key: "maritalStatus",
                    input: true,
                    placeholder: "--select--",
                    errors: {
                        required: "{{ field }} is required."
                    },
                    validate: {
                        required: true
                    },
                    data: {
                        values: [
                            {
                                label: "Single",
                                value: "Single"
                            },
                            {
                                label: "Married",
                                value: "Married"
                            },
                            {
                                label: "Widow",
                                value: "Widow"
                            },
                            {
                                label: "Divorced",
                                value: "Divorced"
                            },
                            {
                                label: "Separated",
                                value: "Separated"
                            },
                            {
                                label: "Others",
                                value: "Others"
                            }
                        ]
                    }
                }
            },
            nationality: {
                title: "Nationality",
                input: false,
                icon: "flag",
                schema: {
                    label: "Nationality",
                    type: "textfield",
                    key: "nationality",
                    input: true,
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "Invalid nationality format."
                    },
                    validate: {
                        required: true,
                        pattern: "^[a-zA-Z\s]+$"
                    }
                }
            },
            community: {
                title: "Community",
                input: false,
                icon: "users",
                schema: {
                    label: "Community",
                    type: "select",
                    key: "community",
                    input: true,
                    placeholder: "--select--",
                    errors: {
                        required: "{{ field }} is required."
                    },
                    validate: {
                        required: true
                    },
                    data: {
                        values: [
                            { label: "Scheduled Caste", value: "Scheduled Caste" },
                            { label: "Scheduled Tribe", value: "Scheduled Tribe" },
                            { label: "De-notified Tribe", value: "De-notified Tribe" },
                            { label: "Nomatic Tribe", value: "Nomatic Tribe" },
                            { label: "Special Backward Category", value: "Special Backward Category" },
                            { label: "Other Backward Classes", value: "Other Backward Classes" },
                            { label: "General", value: "General" },
                            { label: "Other", value: "Other" }
                        ]
                    }
                }
            }
        }
    },
    educationFields: {
        title: "Education",
        weight: 3,
        components: {
            sslc: {
                title: "SSLC",
                input: true,
                icon: "university",
                schema: {
                    title: "SSLC Details",
                    theme: "primary",
                    collapsible: false,
                    key: "sslcDetails",
                    type: "panel",
                    label: "SSLC",
                    input: true,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification Type",
                                            disabled: true,
                                            tableView: true,
                                            defaultValue: "SSLC / 10th",
                                            validate: {
                                                required: true
                                            },
                                            key: "sslcQualificationType",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "School Name",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                pattern: "^[a-zA-Z&.', -]+$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "The input contains invalid characters. Only alphabets, spaces, ' & . , - are allowed."
                                            },
                                            key: "sslcSchoolName",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Board",
                                            placeholder: "Select",
                                            data: {
                                                values: [
                                                    {
                                                        label: "CBSE",
                                                        value: "CBSE"
                                                    },
                                                    {
                                                        label: "ICSE",
                                                        value: "ICSE"
                                                    },
                                                    {
                                                        label: "State Board",
                                                        value: "State Board"
                                                    },
                                                    {
                                                        label: "Others",
                                                        value: "Others"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "sslcBoard",
                                            type: "select",
                                            input: true,
                                            widget: "choicesjs",
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Start Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "sslcStartDate",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "End Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "sslcEndDate",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Year of Passing",
                                            hideInputLabels: true,
                                            inputsLabelPosition: "top",
                                            useLocaleSettings: false,
                                            fields: {
                                                day: {
                                                    hide: true
                                                },
                                                month: {
                                                    hide: true
                                                },
                                                year: {
                                                    type: "select",
                                                    placeholder: "Select",
                                                    hide: false,
                                                    required: true
                                                }
                                            },
                                            defaultValue: "00/00/0000",
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "sslcYearOfPassing",
                                            type: "day",
                                            tableView: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "No. of Backlogs",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                min: 0,
                                                max: 20
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "sslcBacklogs",
                                            type: "number",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Mode",
                                            placeholder: "Select",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Full Time",
                                                        value: "Full Time"
                                                    },
                                                    {
                                                        label: "Part Time",
                                                        value: "Part Time"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "sslcMode",
                                            type: "select",
                                            widget: "choicesjs",
                                            tableView: true,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "sslcPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "sslcColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    tableView: false
                }
            },
            hsc: {
                title: "HSC",
                input: true,
                icon: "university",
                schema: {
                    title: "HSC Details",
                    theme: "primary",
                    collapsible: false,
                    key: "hscDetails",
                    type: "panel",
                    label: "HSC",
                    input: true,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification Type",
                                            disabled: true,
                                            defaultValue: "HSC / 12th",
                                            validate: {
                                                required: true
                                            },
                                            key: "hscQualificationType",
                                            type: "textfield",
                                            tableView: true,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Specialization",
                                            placeholder: "--Select--",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Science",
                                                        value: "Science"
                                                    },
                                                    {
                                                        label: "Commerce",
                                                        value: "Commerce"
                                                    },
                                                    {
                                                        label: "Arts",
                                                        value: "Arts"
                                                    },
                                                    {
                                                        label: "Others",
                                                        value: "Others"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "hscSpecialization",
                                            type: "select",
                                            input: true,
                                            widget: "choicesjs",
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "School Name",
                                            placeholder: "Enter here",
                                            validate: {
                                                required: true,
                                                pattern: "^[a-zA-Z&.', -]+$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "The input contains invalid characters. Only alphabets, spaces, ' & . , - are allowed."
                                            },
                                            key: "hscSchoolName",
                                            type: "textfield",
                                            input: true,
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "hscBoard",
                                            data: {
                                                values: [
                                                    {
                                                        label: "CBSE",
                                                        value: "CBSE"
                                                    },
                                                    {
                                                        label: "ICSE",
                                                        value: "ICSE"
                                                    },
                                                    {
                                                        label: "State Board",
                                                        value: "State Board"
                                                    },
                                                    {
                                                        label: "Others",
                                                        value: "Others"
                                                    }
                                                ]
                                            },
                                            type: "select",
                                            input: true,
                                            label: "Board",
                                            widget: "choicesjs",
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true
                                            },
                                            tableView: true,
                                            placeholder: "--Select--",
                                            searchEnabled: false
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Start Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "hscStartDate",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "End Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "hscEndDate",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Year of Passing",
                                            hideInputLabels: true,
                                            inputsLabelPosition: "top",
                                            useLocaleSettings: false,
                                            fields: {
                                                day: {
                                                    hide: true
                                                },
                                                month: {
                                                    hide: true
                                                },
                                                year: {
                                                    type: "select",
                                                    placeholder: "Select",
                                                    hide: false,
                                                    required: true
                                                }
                                            },
                                            defaultValue: "00/00/0000",
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "hscYearOfPassing",
                                            type: "day",
                                            tableView: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "No. of Backlogs",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                min: 0,
                                                max: 20
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "hscBacklogs",
                                            type: "number",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Mode",
                                            placeholder: "Select",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Full Time",
                                                        value: "Full Time"
                                                    },
                                                    {
                                                        label: "Part Time",
                                                        value: "Part Time"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "hscMode",
                                            type: "select",
                                            widget: "choicesjs",
                                            tableView: true,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "hscPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "hscColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    tableView: false
                }
            },
            diploma: {
                title: "Diploma",
                icon: "university",
                schema: {
                    title: "Diploma Details",
                    theme: "primary",
                    collapsible: false,
                    key: "diplomaDetails",
                    type: "panel",
                    label: "Diploma",
                    input: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification Type",
                                            disabled: true,
                                            defaultValue: "Diploma",
                                            validate: {
                                                required: true
                                            },
                                            key: "diplomaQualificationType",
                                            type: "textfield",
                                            tableView: true,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification",
                                            key: "diplomaQualification",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Diploma Engineering",
                                                        value: "Diploma Engineering"
                                                    }
                                                ]
                                            },
                                            type: "select",
                                            input: true,
                                            widget: "choicesjs",
                                            idPath: "value",
                                            valueProperty: "value",
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true
                                            },
                                            tableView: true,
                                            placeholder: "--Select--",
                                            searchEnabled: false
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Specialization",
                                            placeholder: "--Select--",
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/functional-masters?slugType=diploma-specialization",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            valueProperty: "value.id",
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "diplomaSpecialization",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            widget: "choicesjs",
                                            tableView: true,
                                            dataType: "object",
                                            idPath: "value",
                                            clearOnRefresh: true,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "State",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/state?country=101",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "diplomaState",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "District",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/district?state={{ data.diplomaState.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            refreshOn: "diplomaState",
                                            clearOnRefresh: true,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "diplomaDistrict",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "College Name",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/college?district={{ data.diplomaDistrict.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            refreshOn: "diplomaDistrict",
                                            clearOnRefresh: true,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "diplomaCollegeName",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            key: "diplomaBoardUniversity",
                                            type: "textfield",
                                            input: true,
                                            label: "Board / University",
                                            placeholder: "Enter here",
                                            errors: {
                                                pattern: "Please use only alphabetic characters and spaces.",
                                                maxLength: 150
                                            },
                                            validate: {
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                            },
                                            tableView: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Start Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "diplomaStartDate",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "End Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "diplomaEndDate",
                                            type: "datetime",
                                            input: true,
                                            tableView: false,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Year of Passing",
                                            hideInputLabels: true,
                                            inputsLabelPosition: "top",
                                            useLocaleSettings: false,
                                            fields: {
                                                day: {
                                                    hide: true
                                                },
                                                month: {
                                                    hide: true
                                                },
                                                year: {
                                                    type: "select",
                                                    placeholder: "Select",
                                                    hide: false,
                                                    required: true
                                                }
                                            },
                                            defaultValue: "00/00/0000",
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "diplomaYearOfPassing",
                                            type: "day",
                                            tableView: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "No. of Backlogs",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                min: 0,
                                                max: 20
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "diplomaBacklogs",
                                            type: "number",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Mode",
                                            placeholder: "Select",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Full Time",
                                                        value: "Full Time"
                                                    },
                                                    {
                                                        label: "Part Time",
                                                        value: "Part Time"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "diplomaMode",
                                            type: "select",
                                            widget: "choicesjs",
                                            tableView: true,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "diplomaPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Final Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "diplomaFinalPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "diplomaColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    tableView: false
                }
            },
            ugDegree: {
                title: "UG",
                input: true,
                icon: "graduation-cap",
                schema: {
                    title: "UG Details",
                    theme: "primary",
                    collapsible: false,
                    key: "ugDetails",
                    type: "panel",
                    label: "UG",
                    input: true,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification Type",
                                            disabled: true,
                                            tableView: true,
                                            defaultValue: "Undergraduate",
                                            validate: {
                                                required: true
                                            },
                                            key: "ugQualificationType",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/functional-masters?degreeId=3",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "ugQualification",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Specialization",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/functional-masters?slugType=ug-specialization",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "ugSpecialization",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "State",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/state?country=101",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "ugState",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "District ",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/district?state={{ data.ugState.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "ugDistrict",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "College Name",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/college?district={{ data.ugDistrict.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "ugCollegeName",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Board / University",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "ugBoardUniversity",
                                            placeholder: "Enter here",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Start Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            tableView: false,
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "ugStartDate",
                                            type: "datetime",
                                            input: true,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "End Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            tableView: false,
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "ugEndDate",
                                            type: "datetime",
                                            input: true,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Year of Passing",
                                            hideInputLabels: true,
                                            inputsLabelPosition: "top",
                                            useLocaleSettings: false,
                                            tableView: false,
                                            fields: {
                                                day: {
                                                    hide: true
                                                },
                                                month: {
                                                    hide: true
                                                },
                                                year: {
                                                    type: "select",
                                                    placeholder: "Select",
                                                    hide: false,
                                                    required: true
                                                }
                                            },
                                            defaultValue: "00/00/0000",
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "ugYearOfPassing",
                                            type: "day",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "No. of Backlogs",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                min: 0,
                                                max: 20
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "ugBacklogs",
                                            type: "number",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Mode",
                                            widget: "choicesjs",
                                            placeholder: "Select",
                                            tableView: true,
                                            data: {
                                                values: [
                                                    {
                                                        label: "Full Time",
                                                        value: "Full Time"
                                                    },
                                                    {
                                                        label: "Part Time",
                                                        value: "Part Time"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "ugMode",
                                            type: "select",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "ugPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Final Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "ugFinalPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "ugColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    tableView: false
                }
            },
            pgDegree: {
                title: "PG",
                icon: "graduation-cap",
                schema: {
                    title: "PG Details",
                    theme: "primary",
                    collapsible: false,
                    key: "pgDetails",
                    type: "panel",
                    label: "PG",
                    input: true,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification Type",
                                            disabled: true,
                                            tableView: true,
                                            defaultValue: "Postgraduate",
                                            validate: {
                                                required: true
                                            },
                                            key: "pgQualificationType",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Qualification",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/functional-masters?degreeId=4",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "pgQualification",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Specialization",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/functional-masters?slugType=pg-specialization",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            key: "pgSpecialization",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "State",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/state?country=101",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "pgState",
                                            type: "select",
                                            lazyLoad: false,
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            searchDebounce: 0,
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "District ",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/district?state={{ data.pgState.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            clearOnHide: false,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "pgDistrict",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "College Name",
                                            widget: "choicesjs",
                                            placeholder: "--Select--",
                                            tableView: true,
                                            dataSrc: "url",
                                            data: {
                                                url: "BASE_URL/api/college?district={{ data.pgDistrict.id }}",
                                                headers: [
                                                    {
                                                        key: "Authorization",
                                                        value: "Bearer 2|7zv3KXYk5FYUj9b9Gss0GGwAEn3s7Jfe1GizBjNx"
                                                    }
                                                ]
                                            },
                                            dataType: "object",
                                            idPath: "value",
                                            valueProperty: "value.id",
                                            clearOnRefresh: true,
                                            validate: {
                                                required: true,
                                                select: false
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "pgCollegeName",
                                            type: "select",
                                            selectValues: "data",
                                            disableLimit: false,
                                            searchField: "search",
                                            noRefreshOnScroll: false,
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Board / University",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$",
                                                maxLength: 150
                                            },
                                            errors: {
                                                required: "{{ field }} is required.",
                                                pattern: "Please use only alphabetic characters and spaces."
                                            },
                                            key: "pgBoardUniversity",
                                            placeholder: "Enter here",
                                            type: "textfield",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Start Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            tableView: false,
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "pgStartDate",
                                            type: "datetime",
                                            input: true,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "End Date",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            tableView: false,
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "pgEndDate",
                                            type: "datetime",
                                            input: true,
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: false,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            label: "Year of Passing",
                                            hideInputLabels: true,
                                            inputsLabelPosition: "top",
                                            useLocaleSettings: false,
                                            tableView: false,
                                            fields: {
                                                day: {
                                                    hide: true
                                                },
                                                month: {
                                                    hide: true
                                                },
                                                year: {
                                                    type: "select",
                                                    placeholder: "Select",
                                                    hide: false,
                                                    required: true
                                                }
                                            },
                                            defaultValue: "00/00/0000",
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "pgYearOfPassing",
                                            type: "day",
                                            input: true
                                        }
                                    ],
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "No. of Backlogs",
                                            placeholder: "Enter here",
                                            tableView: true,
                                            validate: {
                                                required: true,
                                                min: 0,
                                                max: 20
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "pgBacklogs",
                                            type: "number",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Mode",
                                            widget: "choicesjs",
                                            placeholder: "Select",
                                            tableView: true,
                                            data: {
                                                values: [
                                                    {
                                                        label: "Full Time",
                                                        value: "Full Time"
                                                    },
                                                    {
                                                        label: "Part Time",
                                                        value: "Part Time"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            validate: {
                                                required: true
                                            },
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            key: "pgMode",
                                            type: "select",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "pgPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Final Percentage(%)",
                                            placeholder: "Enter here",
                                            mask: false,
                                            tableView: true,
                                            delimiter: false,
                                            requireDecimal: false,
                                            inputFormat: "plain",
                                            truncateMultipleSpaces: true,
                                            validate: {
                                                required: true,
                                                min: 50,
                                                max: 100
                                            },
                                            key: "pgFinalPercentage",
                                            type: "number",
                                            decimalLimit: 2,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "pgColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ],
                    tableView: false
                }
            }
        }
    },
    verificationFields: {
        title: "Verifications",
        weight: 4,
        components: {
            mobileNumber: {
                title: 'Mobile Number',
                icon: 'phone-square',
                schema: {
                    label: 'Mobile Number',
                    key: 'mobileNumber',
                    type: 'textfield',
                    input: true,
                    prefix: '+91',
                    suffix: '<a href="#" class="verify-input disabled-link" id="verify-mobile-no"><u>Verify</u></a>',
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "Please enter a 10-digit mobile number starting with 6, 7, 8, or 9."
                    },
                    validate: {
                        required: true,
                        pattern: '^[6-9]\\d{9}$',
                        custom: 'var val = parseInt(data.mobileNumber); if(val.toString().length === 10) { var isValid = instance.checkValidity(); if(isValid) { $("#verify-mobile-no").removeClass("disabled-link"); } else { $("#verify-mobile-no").addClass("disabled-link"); } } else { $("#verify-mobile-no").addClass("disabled-link"); }'
                    },
                    inputMask: '9999999999',
                    displayMask: '9999999999',
                    tableView: true
                }
            },
            emailId: {
                title: 'Email Id',
                icon: 'at',
                schema: {
                    label: 'Email Id',
                    key: 'emailId',
                    type: 'email',
                    input: true,
                    suffix: '<a href="#" class="verify-input disabled-link" id="verify-email-id"><u>Verify</u></a>',
                    errors: {
                        required: "{{ field }} is required.",
                        pattern: "The email must not start/end with a dot, contain spaces/special chars, but can have dots in the middle and a double domain ('.de.org' or similar rarity)."
                    },
                    validate: {
                        required: true,
                        custom: 'var val = data.emailId;if(val.toString().length >= 10) { var isValid = instance.checkValidity(); if(isValid) { $("#verify-email-id").removeClass("disabled-link"); } else { $("#verify-email-id").addClass("disabled-link"); } } else { $("#verify-email-id").addClass("disabled-link"); }'
                    },
                    tableView: true
                }
            }
        }
    },
    documents: {
        title: "Documents",
        weight: 5,
        components: {
            uploadImage: {
                title: "Upload Image",
                key: "uploadImage",
                icon: "image",
                schema: {
                    key: "uploadPhotograph",
                    type: "panel",
                    input: false,
                    label: "Panel",
                    theme: "primary",
                    title: "UPLOAD PHOTOGRAPH",
                    tableView: false,
                    components: [
                        {
                            key: "columns4",
                            type: "columns",
                            input: false,
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    components: [
                                        {
                                            dir: "profile-images",
                                            key: "uploadPhotographJpgJpegFormatOnly",
                                            url: `storage/azure?_token={{csrfToken}}&exts=jpeg,jpg&dms=139*179&checkFaceDetection=true`,
                                            type: "file",
                                            image: true,
                                            input: true,
                                            label: "Upload PHOTOGRAPH (JPG/JPEG Format only)",
                                            webcam: false,
                                            storage: "url",
                                            validate: {
                                                required: true
                                            },
                                            fileTypes: [
                                                {
                                                    label: "JPG",
                                                    value: "jpg"
                                                },
                                                {
                                                    label: "JPEG",
                                                    value: "jpeg"
                                                }
                                            ],
                                            imageSize: "139",
                                            tableView: false,
                                            fileMaxSize: "200KB",
                                            fileMinSize: "5KB",
                                            content: "Click<a href=\"https://imageresizer.com/\" target=\"_blank\"> HERE </a> to resize your image"
                                        }
                                    ],
                                    currentWidth: 8
                                }
                            ],
                            autoAdjust: true,
                            tableView: false
                        },
                        {
                            key: "html4",
                            tag: "p",
                            type: "htmlelement",
                            attrs: [
                                {
                                    attr: "",
                                    value: ""
                                }
                            ],
                            input: false,
                            label: "HTML",
                            content: "<p>Click<a href=\"https://imageresizer.com/\" target=\"_blank\"> HERE </a> to resize your image</p>",
                            tableView: false,
                            refreshOnChange: false
                        }
                    ],
                    collapsible: false
                }
            },
            uploadSignature: {
                title: "Upload Signature",
                key: "uploadSign",
                input: false,
                icon: "edit",
                schema: {
                    key: "uploadSignature",
                    type: "panel",
                    input: false,
                    label: "Panel",
                    theme: "primary",
                    title: "UPLOAD SIGNATURE",
                    components: [
                        {
                            key: "columns5",
                            type: "columns",
                            input: false,
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 8,
                                    offset: 0,
                                    components: [
                                        {
                                            dir: "signature",
                                            key: "uploadSignatureJpgJpegFormatOnly",
                                            url: `storage/azure?_token={{csrfToken}}&exts=jpeg,jpg&dms=226*113`,
                                            type: "file",
                                            image: true,
                                            input: true,
                                            label: "Upload SIGNATURE (JPG/JPEG Format only)",
                                            webcam: false,
                                            storage: "url",
                                            validate: {
                                                required: true
                                            },
                                            fileTypes: [
                                                {
                                                    label: "JPG",
                                                    value: "jpg"
                                                },
                                                {
                                                    label: "JPEG",
                                                    value: "jpeg"
                                                }
                                            ],
                                            imageSize: "226",
                                            tableView: false,
                                            fileMaxSize: "200KB",
                                            fileMinSize: "2KB"
                                        }
                                    ],
                                    currentWidth: 8
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 4,
                                    offset: 0,
                                    components: [],
                                    currentWidth: 4
                                }
                            ],
                            autoAdjust: true,
                            tableView: false
                        }
                    ],
                    collapsible: false
                }
            },
            uploadResume: {
                title: "Upload Resume PDF",
                key: "uploadResume",
                input: false,
                icon: "file",
                schema: {
                    key: "uploadResume",
                    type: "panel",
                    input: false,
                    label: "Panel",
                    theme: "primary",
                    title: "UPLOAD RESUME",
                    components: [
                        {
                            key: "columns5",
                            type: "columns",
                            input: false,
                            label: "Columns",
                            columns: [
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 8,
                                    offset: 0,
                                    components: [
                                        {
                                            dir: "resume",
                                            key: "uploadResume",
                                            url: `storage/azure?_token={{csrfToken}}&exts=pdf`,
                                            type: "file",
                                            image: true,
                                            input: true,
                                            label: "Upload Resume (Pdf Format only)",
                                            webcam: false,
                                            storage: "url",
                                            validate: {
                                                required: true
                                            },
                                            fileTypes: [
                                                {
                                                    label: "PDF",
                                                    value: "pdf"
                                                }
                                            ],
                                            tableView: false,
                                            fileMaxSize: "4000KB",
                                            fileMinSize: "2KB"
                                        }
                                    ],
                                    currentWidth: 8
                                },
                                {
                                    pull: 0,
                                    push: 0,
                                    size: "md",
                                    width: 4,
                                    offset: 0,
                                    components: [],
                                    currentWidth: 4
                                }
                            ],
                            autoAdjust: true,
                            tableView: false
                        }
                    ],
                    collapsible: false
                }
            }
        }
    },
    experienceFields: {
        title: "Work Experience",
        weight: 6,
        components: {
            skills: {
                title: 'Skills',
                icon: "cogs",
                schema: {
                    title: "Skills",
                    theme: "primary",
                    collapsible: false,
                    key: "skills",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Add your Skills",
                            placeholder: "Enter here",
                            tableView: true,
                            multiple: true,
                            key: "addYourSkills",
                            type: "textfield",
                            input: true
                        }
                    ]
                }
            },
            certificationdetails: {
                title: "Certification Details",
                icon: "certificate",
                schema: {
                    title: "Certification Details",
                    collapsible: false,
                    key: "certificationDetails",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    theme: "primary",
                    components: [
                        {
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Do you hold any certifications?",
                                            widget: "choicesjs",
                                            tableView: true,
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true
                                            },
                                            key: "doYouHoldAnyCertifications",
                                            type: "select",
                                            input: true,
                                            defaultValue: "No"
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "certificationDetailsColumns1",
                            type: "columns",
                            input: false,
                            tableView: false,
                            label: "Columns"
                        },
                        {
                            label: "Certification Details",
                            hideLabel: true,
                            key: "certificationDetailsWell",
                            conditional: {
                                show: true,
                                when: "doYouHoldAnyCertifications",
                                eq: "Yes"
                            },
                            type: "well",
                            input: false,
                            tableView: false,
                            components: [
                                {
                                    label: "Certification Details",
                                    reorder: false,
                                    addAnotherPosition: "bottom",
                                    layoutFixed: false,
                                    enableRowGroups: false,
                                    initEmpty: false,
                                    hideLabel: true,
                                    tableView: false,
                                    clearOnHide: false,
                                    key: "certificationDetailsDataGrid",
                                    type: "datagrid",
                                    input: true,
                                    keyModified: true,
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "Certification Name",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "certificationName",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Issue Date",
                                                            allowInput: false,
                                                            format: "dd-MMM-yyyy",
                                                            datePicker: {
                                                                disableWeekends: false,
                                                                disableWeekdays: false
                                                            },
                                                            enableTime: false,
                                                            timePicker: {
                                                                showMeridian: false
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            enableMinDateInput: false,
                                                            enableMaxDateInput: false,
                                                            key: "issueDate",
                                                            type: "datetime",
                                                            input: false,
                                                            tableView: false,
                                                            template: "<div><label>Issue Date</label><input type='date' ref='input' readonly class='form-control'></div>",
                                                            widget: {
                                                                type: "calendar",
                                                                displayInTimezone: "viewer",
                                                                locale: "en",
                                                                useLocaleSettings: false,
                                                                allowInput: false,
                                                                mode: "single",
                                                                enableTime: false,
                                                                noCalendar: false,
                                                                format: "dd-MMM-yyyy",
                                                                hourIncrement: 1,
                                                                minuteIncrement: 1,
                                                                time_24hr: true,
                                                                minDate: null,
                                                                disableWeekends: false,
                                                                disableWeekdays: false,
                                                                maxDate: null
                                                            }
                                                        }
                                                    ],
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Is there a validity period of the certificate issued?",
                                                            data: {
                                                                values: [
                                                                    {
                                                                        label: "Yes",
                                                                        value: "Yes"
                                                                    },
                                                                    {
                                                                        label: "No",
                                                                        value: "No"
                                                                    }
                                                                ]
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            key: "isThereAValidityPeriodOfTheCertificateIssued",
                                                            type: "select",
                                                            widget: "choicesjs",
                                                            tableView: true,
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Expiry Date",
                                                            allowInput: false,
                                                            format: "dd-MMM-yyyy",
                                                            datePicker: {
                                                                disableWeekends: false,
                                                                disableWeekdays: false
                                                            },
                                                            enableTime: false,
                                                            timePicker: {
                                                                showMeridian: false
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            enableMinDateInput: false,
                                                            enableMaxDateInput: false,
                                                            key: "expiryDate",
                                                            conditional: {
                                                                show: true,
                                                                when: "dataGrid.isThereAValidityPeriodOfTheCertificateIssued",
                                                                eq: "Yes"
                                                            },
                                                            type: "datetime",
                                                            input: false,
                                                            tableView: false,
                                                            template: "<div><label>Expiry Date</label><input type='date' ref='input' readonly class='form-control'></div>",
                                                            widget: {
                                                                type: "calendar",
                                                                displayInTimezone: "viewer",
                                                                locale: "en",
                                                                useLocaleSettings: false,
                                                                allowInput: false,
                                                                mode: "single",
                                                                enableTime: false,
                                                                noCalendar: false,
                                                                format: "dd-MMM-yyyy",
                                                                hourIncrement: 1,
                                                                minuteIncrement: 1,
                                                                time_24hr: true,
                                                                minDate: null,
                                                                disableWeekends: false,
                                                                disableWeekdays: false,
                                                                maxDate: null
                                                            }
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Certificate ID / Certificate Number",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphanumeric",
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[a-zA-Z0-9]+$"
                                                            },
                                                            key: "certificateIdCertificateNumber",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Certificate URL",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                pattern: "Invalid Url format. Please enter a valid one.This URLs starting with \"http\", \"https\", or \"ftp\" protocols."
                                                            },
                                                            validate: {
                                                                pattern: "^(https?|ftp)://[^\s/$.?#].[^\s]*$"
                                                            },
                                                            key: "certificateUrl",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Is this certificate Issued by L&T EduTech",
                                                            widget: "choicesjs",
                                                            tableView: true,
                                                            data: {
                                                                values: [
                                                                    {
                                                                        label: "Yes",
                                                                        value: "Yes"
                                                                    },
                                                                    {
                                                                        label: "No",
                                                                        value: "No"
                                                                    }
                                                                ]
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            key: "isThisCertificateIssuedByLTEduTech",
                                                            type: "select",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Certificate Issuing Organization Name",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "certificateIssuingOrganizationName",
                                                            conditional: {
                                                                show: true,
                                                                when: "dataGrid.isThisCertificateIssuedByLTEduTech",
                                                                eq: "No"
                                                            },
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                }
                                            ],
                                            autoAdjust: true,
                                            hideLabel: true,
                                            key: "certificationDetailsColumns2",
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            articleshiptrainingdetails: {
                title: "Articleship/Training Details",
                icon: "chart-bar",
                schema: {
                    title: "Articleship/Training Details",
                    theme: "primary",
                    collapsible: false,
                    key: "articleshipTrainingDetailsPanel",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Do you have any Articleship or Industrial training Experience?",
                            tableView: false,
                            defaultValue: false,
                            clearOnHide: false,
                            key: "doYouHaveAnyArticleshipOrIndustrialTrainingExperience",
                            type: "checkbox",
                            input: true
                        },
                        {
                            label: "Articleship/Training Details",
                            key: "articleshipTrainingDetails",
                            conditional: {
                                show: true,
                                when: "doYouHaveAnyArticleshipOrIndustrialTrainingExperience",
                                eq: "true"
                            },
                            type: "well",
                            input: false,
                            tableView: false,
                            components: [
                                {
                                    label: "Articleship / Training",
                                    reorder: false,
                                    addAnotherPosition: "bottom",
                                    layoutFixed: false,
                                    enableRowGroups: false,
                                    initEmpty: false,
                                    hideLabel: true,
                                    tableView: false,
                                    clearOnHide: false,
                                    key: "articleshipTraining",
                                    type: "datagrid",
                                    input: true,
                                    keyModified: true,
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "Name of Employer",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "nameOfEmployer",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Duration From",
                                                            allowInput: false,
                                                            format: "dd-MMM-yyyy",
                                                            datePicker: {
                                                                disableWeekends: false,
                                                                disableWeekdays: false
                                                            },
                                                            enableTime: false,
                                                            timePicker: {
                                                                showMeridian: false
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            enableMinDateInput: false,
                                                            enableMaxDateInput: false,
                                                            key: "durationFrom",
                                                            type: "datetime",
                                                            input: false,
                                                            tableView: false,
                                                            template: "<div><label>Duration From</label><input type='date' ref='input' readonly class='form-control'></div>",
                                                            widget: {
                                                                type: "calendar",
                                                                displayInTimezone: "viewer",
                                                                locale: "en",
                                                                useLocaleSettings: false,
                                                                allowInput: false,
                                                                mode: "single",
                                                                enableTime: false,
                                                                noCalendar: false,
                                                                format: "dd-MMM-yyyy",
                                                                hourIncrement: 1,
                                                                minuteIncrement: 1,
                                                                time_24hr: true,
                                                                minDate: null,
                                                                disableWeekends: false,
                                                                disableWeekdays: false,
                                                                maxDate: null
                                                            }
                                                        }
                                                    ],
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Duration To",
                                                            allowInput: false,
                                                            format: "dd-MMM-yyyy",
                                                            datePicker: {
                                                                disableWeekends: false,
                                                                disableWeekdays: false
                                                            },
                                                            enableTime: false,
                                                            timePicker: {
                                                                showMeridian: false
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            enableMinDateInput: false,
                                                            enableMaxDateInput: false,
                                                            key: "durationTo",
                                                            type: "datetime",
                                                            input: false,
                                                            tableView: false,
                                                            template: "<div><label>Duration To</label><input type='date' ref='input' readonly class='form-control'></div>",
                                                            widget: {
                                                                type: "calendar",
                                                                displayInTimezone: "viewer",
                                                                locale: "en",
                                                                useLocaleSettings: false,
                                                                allowInput: false,
                                                                mode: "single",
                                                                enableTime: false,
                                                                noCalendar: false,
                                                                format: "dd-MMM-yyyy",
                                                                hourIncrement: 1,
                                                                minuteIncrement: 1,
                                                                time_24hr: true,
                                                                minDate: null,
                                                                disableWeekends: false,
                                                                disableWeekdays: false,
                                                                maxDate: null
                                                            }
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Details of Work Responsibility",
                                                            placeholder: "Enter here",
                                                            autoExpand: false,
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$"
                                                            },
                                                            key: "detailsOfWorkResponsibility",
                                                            type: "textarea",
                                                            isUploadEnabled: false,
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                }
                                            ],
                                            autoAdjust: true,
                                            hideLabel: true,
                                            key: "articleshipTrainingDetailsColumnsWell",
                                            conditional: {
                                                show: true,
                                                when: "doYouHaveAnyArticleshipOrIndustrialTrainingExperience",
                                                eq: "true"
                                            },
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Whether Articleship completed as per the requirement of Institute?",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "Yes",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true
                                            },
                                            key: "whetherArticleshipCompletedAsPerTheRequirementOfInstitute",
                                            type: "select",
                                            input: true
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Expected date of completion: ",
                                            allowInput: false,
                                            format: "dd-MMM-yyyy",
                                            datePicker: {
                                                disableWeekends: false,
                                                disableWeekdays: false
                                            },
                                            enableTime: false,
                                            timePicker: {
                                                showMeridian: false
                                            },
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true
                                            },
                                            enableMinDateInput: false,
                                            enableMaxDateInput: false,
                                            key: "expectedDateOfCompletion",
                                            conditional: {
                                                show: true,
                                                when: "whetherArticleshipCompletedAsPerTheRequirementOfInstitute",
                                                eq: "No"
                                            },
                                            type: "datetime",
                                            input: false,
                                            tableView: false,
                                            template: "<div><label>Expected date of completion</label><input type='date' ref='input' readonly class='form-control'></div>",
                                            widget: {
                                                type: "calendar",
                                                displayInTimezone: "viewer",
                                                locale: "en",
                                                useLocaleSettings: false,
                                                allowInput: false,
                                                mode: "single",
                                                enableTime: false,
                                                noCalendar: false,
                                                format: "dd-MMM-yyyy",
                                                hourIncrement: 1,
                                                minuteIncrement: 1,
                                                time_24hr: true,
                                                minDate: null,
                                                disableWeekends: false,
                                                disableWeekdays: false,
                                                maxDate: null
                                            }
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                }
                            ],
                            key: "articleshipTrainingDetailsColumns2",
                            conditional: {
                                show: true,
                                when: "doYouHaveAnyArticleshipOrIndustrialTrainingExperience",
                                eq: "true"
                            },
                            autoAdjust: true,
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            employmentDetails: {
                title: "Employment Details",
                icon: "address-card",
                schema: {
                    title: "Employment Details",
                    theme: "primary",
                    collapsible: false,
                    key: "employmentDetails",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Do you have any Work Experience?",
                            tableView: false,
                            clearOnHide: false,
                            key: "doYouHaveAnyWorkExperience",
                            type: "checkbox",
                            input: true,
                            defaultValue: false
                        },
                        {
                            label: "Employment Details",
                            hideLabel: true,
                            key: "employmentDetailsWell",
                            conditional: {
                                show: true,
                                when: "doYouHaveAnyWorkExperience",
                                eq: "true"
                            },
                            type: "well",
                            input: false,
                            tableView: false,
                            components: [
                                {
                                    label: "Employment Details",
                                    reorder: false,
                                    addAnotherPosition: "bottom",
                                    layoutFixed: false,
                                    enableRowGroups: false,
                                    initEmpty: false,
                                    hideLabel: true,
                                    tableView: false,
                                    clearOnHide: false,
                                    key: "employmentDetailsDataGrid",
                                    type: "datagrid",
                                    input: true,
                                    components: [
                                        {
                                            label: "Columns",
                                            hideLabel: true,
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "Employer's Name & Address",
                                                            placeholder: "Enter here",
                                                            autoExpand: false,
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$"
                                                            },
                                                            key: "employersNameAddress",
                                                            type: "textarea",
                                                            input: true
                                                        }
                                                    ],
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 4,
                                                    width: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Duration From",
                                                            allowInput: false,
                                                            format: "dd-MMM-yyyy",
                                                            datePicker: {
                                                                disableWeekends: false,
                                                                disableWeekdays: false
                                                            },
                                                            enableTime: false,
                                                            timePicker: {
                                                                showMeridian: false
                                                            },
                                                            clearOnHide: false,
                                                            erros: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            enableMinDateInput: false,
                                                            enableMaxDateInput: false,
                                                            key: "durationFromEmployment",
                                                            type: "datetime",
                                                            input: false,
                                                            tableView: false,
                                                            template: "<div><label>Duration From</label><input type='date' ref='input' readonly class='form-control'></div>",
                                                            widget: {
                                                                type: "calendar",
                                                                displayInTimezone: "viewer",
                                                                locale: "en",
                                                                useLocaleSettings: false,
                                                                allowInput: false,
                                                                mode: "single",
                                                                enableTime: false,
                                                                noCalendar: false,
                                                                format: "dd-MMM-yyyy",
                                                                hourIncrement: 1,
                                                                minuteIncrement: 1,
                                                                time_24hr: true,
                                                                minDate: null,
                                                                disableWeekends: false,
                                                                disableWeekdays: false,
                                                                maxDate: null
                                                            }
                                                        }
                                                    ],
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 4,
                                                    width: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Duration To",
                                                            allowInput: false,
                                                            format: "dd-MMM-yyyy",
                                                            datePicker: {
                                                                disableWeekends: false,
                                                                disableWeekdays: false
                                                            },
                                                            enableTime: false,
                                                            timePicker: {
                                                                showMeridian: false
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            enableMinDateInput: false,
                                                            enableMaxDateInput: false,
                                                            key: "durationToEmployment",
                                                            type: "datetime",
                                                            input: false,
                                                            tableView: false,
                                                            template: "<div><label>Duration To</label><input type='date' ref='input' readonly class='form-control'></div>",
                                                            widget: {
                                                                type: "calendar",
                                                                displayInTimezone: "viewer",
                                                                locale: "en",
                                                                useLocaleSettings: false,
                                                                allowInput: false,
                                                                mode: "single",
                                                                enableTime: false,
                                                                noCalendar: false,
                                                                format: "dd-MMM-yyyy",
                                                                hourIncrement: 1,
                                                                minuteIncrement: 1,
                                                                time_24hr: true,
                                                                minDate: null,
                                                                disableWeekends: false,
                                                                disableWeekdays: false,
                                                                maxDate: null
                                                            }
                                                        }
                                                    ],
                                                    size: "md",
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    width: 4,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Position Held",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "positionHeld",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    width: 4,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Name & Designation of Immediate Superior",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces.",
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "nameDesignationOfImmediateSuperior",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    width: 4,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Gross Emoluments (Per Month)",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "This gross format that includes digits, with an optional thousands separator (comma) and an optional decimal part with two digits."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^(\\d{1,3}(,\\d{3})*(\\.\\d{1,2})?|\\d+(\\.\\d{1,2})?)$"
                                                            },
                                                            key: "grossEmolumentsPerMonth",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    width: 4,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "HR Name",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "hrName",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "HR Contact Number",
                                                            placeholder: "Enter here",
                                                            prefix: "+91",
                                                            inputMask: "9999999999",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please enter a 10-digit mobile number starting with 6, 7, 8, or 9."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[6-9]\\d{9}$"
                                                            },
                                                            key: "hrContactNumber",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "HR Email ID",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                custom: "{{ field }} is already exist.",
                                                                required: "{{ field }} is required."
                                                            },
                                                            unique: true,
                                                            validate: {
                                                                required: true
                                                            },
                                                            key: "hrEmailId",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 4,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 4
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Nature of Work Done",
                                                            autoExpand: false,
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "natureOfWorkDone",
                                                            placeholder: "Enter here",
                                                            type: "textarea",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Reason for Leaving",
                                                            placeholder: "Enter here",
                                                            autoExpand: false,
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "reasonForLeaving",
                                                            type: "textarea",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 6,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 6
                                                }
                                            ],
                                            autoAdjust: true,
                                            key: "employmentDetailsColumns",
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            label: "Columns",
                            hideLabel: true,
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "HTML",
                                            attrs: [
                                                {
                                                    attr: "",
                                                    value: ""
                                                }
                                            ],
                                            content: "Total Experience",
                                            refreshOnChange: false,
                                            key: "html",
                                            type: "htmlelement",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 4,
                                    width: 4
                                },
                                {
                                    components: [
                                        {
                                            label: "Break in Employment, If any, Should be indicated with reasons",
                                            placeholder: "Enter here...",
                                            autoExpand: false,
                                            tableView: true,
                                            clearOnHide: false,
                                            errors: {
                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only."
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$"
                                            },
                                            key: "breakInEmploymentIfAnyShouldBeIndicatedWithReasons",
                                            type: "textarea",
                                            input: true
                                        }
                                    ],
                                    width: 8,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 8
                                }
                            ],
                            autoAdjust: true,
                            key: "columns2",
                            conditional: {
                                show: true,
                                when: "doYouHaveAnyWorkExperience",
                                eq: "true"
                            },
                            type: "columns",
                            input: false,
                            tableView: false
                        },
                        {
                            label: "Columns",
                            hideLabel: true,
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Have you ever been employed by us or by any of our subsidiary / associate companies before? (If so please mention the name of our company and / or any of our subsidiary / associate companies and your payslip number)",
                                            optionsLabelPosition: "right",
                                            inline: false,
                                            tableView: false,
                                            values: [
                                                {
                                                    label: "Yes",
                                                    value: "Yes"
                                                },
                                                {
                                                    label: "No",
                                                    value: "No"
                                                }
                                            ],
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true
                                            },
                                            key: "haveYouEverBeenEmployedByUsOrByAnyOfOurSubsidiaryAssociateCompaniesBeforeIfSoPleaseMentionTheNameOfOurCompanyAndOrAnyOfOurSubsidiaryAssociateCompaniesAndYourPayslipNumber",
                                            type: "radio",
                                            input: true,
                                            defaultValue: "No"
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "HTML",
                                                            tag: "h6",
                                                            attrs: [
                                                                {
                                                                    attr: "",
                                                                    value: ""
                                                                }
                                                            ],
                                                            content: "If, yes, Please give details",
                                                            refreshOnChange: false,
                                                            key: "html1",
                                                            type: "htmlelement",
                                                            input: false,
                                                            tableView: false
                                                        }
                                                    ],
                                                    width: 12,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 12
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "OC: ",
                                                            labelPosition: "left-left",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "oc",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 12,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 12
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Payslip number: ",
                                                            labelPosition: "left-left",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphanumeric."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[a-zA-Z0-9]+$"
                                                            },
                                                            key: "payslipNumber",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 12,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 12
                                                }
                                            ],
                                            autoAdjust: true,
                                            key: "columns5",
                                            conditional: {
                                                show: true,
                                                when: "haveYouEverBeenEmployedByUsOrByAnyOfOurSubsidiaryAssociateCompaniesBeforeIfSoPleaseMentionTheNameOfOurCompanyAndOrAnyOfOurSubsidiaryAssociateCompaniesAndYourPayslipNumber",
                                                eq: "Yes"
                                            },
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Apart from current drive, have you ever interviewed by L&T?",
                                            optionsLabelPosition: "right",
                                            inline: false,
                                            tableView: false,
                                            values: [
                                                {
                                                    label: "Yes",
                                                    value: "Yes"
                                                },
                                                {
                                                    label: "No",
                                                    value: "No"
                                                }
                                            ],
                                            clearOnHide: false,
                                            errors: {
                                                required: "{{ field }} is required."
                                            },
                                            validate: {
                                                required: true
                                            },
                                            key: "apartFromCurrentDriveHaveYouEverInterviewedByLT",
                                            type: "radio",
                                            input: true,
                                            defaultValue: "No"
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Columns",
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "HTML",
                                                            tag: "h6",
                                                            attrs: [
                                                                {
                                                                    attr: "",
                                                                    value: ""
                                                                }
                                                            ],
                                                            content: "If, yes, Please give details",
                                                            refreshOnChange: false,
                                                            key: "html2",
                                                            type: "htmlelement",
                                                            input: false,
                                                            tableView: false
                                                        }
                                                    ],
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 12,
                                                    width: 12
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Post Applied for: ",
                                                            labelPosition: "left-left",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "postAppliedFor",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 12,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 12
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Duration To",
                                                            allowInput: false,
                                                            format: "dd-MMM-yyyy",
                                                            datePicker: {
                                                                disableWeekends: false,
                                                                disableWeekdays: false
                                                            },
                                                            enableTime: false,
                                                            timePicker: {
                                                                showMeridian: false
                                                            },
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required."
                                                            },
                                                            validate: {
                                                                required: true
                                                            },
                                                            enableMinDateInput: false,
                                                            enableMaxDateInput: false,
                                                            key: "durationTo",
                                                            type: "datetime",
                                                            input: false,
                                                            tableView: false,
                                                            template: "<div><label>Duration To</label><input type='date' ref='input' readonly class='form-control'></div>",
                                                            widget: {
                                                                type: "calendar",
                                                                displayInTimezone: "viewer",
                                                                locale: "en",
                                                                useLocaleSettings: false,
                                                                allowInput: false,
                                                                mode: "single",
                                                                enableTime: false,
                                                                noCalendar: false,
                                                                format: "dd-MMM-yyyy",
                                                                hourIncrement: 1,
                                                                minuteIncrement: 1,
                                                                time_24hr: true,
                                                                minDate: null,
                                                                disableWeekends: false,
                                                                disableWeekdays: false,
                                                                maxDate: null
                                                            }
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 12,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 12
                                                }
                                            ],
                                            key: "columns4",
                                            conditional: {
                                                show: true,
                                                when: "apartFromCurrentDriveHaveYouEverInterviewedByLT",
                                                eq: "Yes"
                                            },
                                            autoAdjust: true,
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "columns3",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            relativesAcquaintances: {
                title: "Relatives / Acquaintances",
                icon: "users",
                schema: {
                    title: "Relatives / Acquaintances",
                    theme: "primary",
                    collapsible: false,
                    key: "relativesAcquaintances",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Is any of your Relatives / Acquaintances in L&T group of companies?",
                            tableView: false,
                            clearOnHide: false,
                            key: "isAnyOfYourRelativesAcquaintancesInLTGroupOfCompanies",
                            type: "checkbox",
                            input: true,
                            defaultValue: false
                        },
                        {
                            label: "Relatives / Acquaintances",
                            hideLabel: true,
                            key: "relativesAcquaintancesWell",
                            conditional: {
                                show: true,
                                when: "isAnyOfYourRelativesAcquaintancesInLTGroupOfCompanies",
                                eq: "true"
                            },
                            type: "well",
                            input: false,
                            tableView: false,
                            components: [
                                {
                                    label: "Relatives / Acquaintances",
                                    reorder: false,
                                    addAnotherPosition: "bottom",
                                    layoutFixed: false,
                                    enableRowGroups: false,
                                    initEmpty: false,
                                    hideLabel: true,
                                    tableView: false,
                                    clearOnHide: false,
                                    key: "relativesAcquaintances2",
                                    type: "datagrid",
                                    input: true,
                                    components: [
                                        {
                                            label: "Columns",
                                            hideLabel: true,
                                            columns: [
                                                {
                                                    components: [
                                                        {
                                                            label: "Name",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "name",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3,
                                                    width: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Relationship",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "relationship",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    size: "md",
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Position",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces."
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "position",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 3
                                                },
                                                {
                                                    components: [
                                                        {
                                                            label: "Company",
                                                            placeholder: "Enter here",
                                                            tableView: true,
                                                            clearOnHide: false,
                                                            errors: {
                                                                required: "{{ field }} is required.",
                                                                pattern: "Please use only alphabetic characters and spaces"
                                                            },
                                                            validate: {
                                                                required: true,
                                                                pattern: "^[A-Za-z]+(?: [A-Za-z]+)*$"
                                                            },
                                                            key: "company",
                                                            type: "textfield",
                                                            input: true
                                                        }
                                                    ],
                                                    size: "md",
                                                    width: 3,
                                                    offset: 0,
                                                    push: 0,
                                                    pull: 0,
                                                    currentWidth: 3
                                                }
                                            ],
                                            autoAdjust: true,
                                            key: "relativesAcquaintancesColumns",
                                            type: "columns",
                                            input: false,
                                            tableView: false
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            facultyReferences: {
                title: "Faculty References",
                icon: "user",
                schema: {
                    title: "Faculty References",
                    theme: "primary",
                    collapsible: false,
                    key: "facultyReferences",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Faculty Reference 1",
                                            placeholder: "Enter Faculty Reference 1",
                                            autoExpand: false,
                                            hideLabel: true,
                                            tableView: true,
                                            clearOnHide: false,
                                            key: "facultyReference1",
                                            type: "textarea",
                                            errors: {
                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only"
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 255
                                            },
                                            input: true
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Faculty Reference 2",
                                            placeholder: "Enter Faculty Reference 2",
                                            autoExpand: false,
                                            hideLabel: true,
                                            tableView: true,
                                            clearOnHide: false,
                                            key: "facultyReference2",
                                            type: "textarea",
                                            errors: {
                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only"
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 255
                                            },
                                            input: true
                                        }
                                    ],
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Significant Achievements",
                                            placeholder: "Enter Significant Achievements",
                                            autoExpand: false,
                                            tableView: true,
                                            clearOnHide: false,
                                            key: "significantAchievements",
                                            type: "textarea",
                                            errors: {
                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only"
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 255
                                            },
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                },
                                {
                                    components: [
                                        {
                                            label: "Explain why you consider yourself suitable for L&T",
                                            placeholder: "Explain here...",
                                            autoExpand: false,
                                            tableView: true,
                                            clearOnHide: false,
                                            key: "explainWhyYouConsiderYourselfSuitableForLT",
                                            type: "textarea",
                                            errors: {
                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only"
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 255
                                            },
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 6,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 6
                                }
                            ],
                            autoAdjust: true,
                            key: "columns6",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            },
            disciplinaryDetails: {
                title: "Disciplinary Details",
                icon: "ban",
                schema: {
                    title: "Disciplinary Details",
                    theme: "primary",
                    collapsible: false,
                    key: "disciplinaryDetails",
                    type: "panel",
                    label: "Panel",
                    input: false,
                    tableView: false,
                    components: [
                        {
                            label: "Columns",
                            columns: [
                                {
                                    components: [
                                        {
                                            label: "Have you ever been convicted by a Court of Law?",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails1",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12,
                                    width: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Have you ever been debarred/disqualified from any examination or restricted by any University or any other educational institute?\t",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails2",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    size: "md",
                                    currentWidth: 12,
                                    width: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Have you ever been arrested?\t",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails3",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Have you ever been debarred/disqualified from any Public Service Commission or any other recruiting company for appearing at its examination / selection?",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails4",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Have you ever been prosecuted?",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails5",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Is any case pending against you in any Court of Law at the time of filling this form?",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails6",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Have you ever been kept under detention?",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails7",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Is any case pending against you in any University or Educational Institute at the time of filling this form?",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails8",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Have you ever been fined by a Court of Law?",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails9",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "In the previous employment, were any disciplinary proceedings framed against you or had you been called upon to explain your conduct in any matter at the time you served notice for resignation?\t",
                                            labelPosition: "left-left",
                                            widget: "choicesjs",
                                            tableView: true,
                                            defaultValue: "No",
                                            data: {
                                                values: [
                                                    {
                                                        label: "Yes",
                                                        value: "Yes"
                                                    },
                                                    {
                                                        label: "No",
                                                        value: "No"
                                                    }
                                                ]
                                            },
                                            searchEnabled: false,
                                            clearOnHide: false,
                                            key: "disciplinaryDetails10",
                                            type: "select",
                                            labelWidth: 100,
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                },
                                {
                                    components: [
                                        {
                                            label: "Please give full particulars of the case/arrest/detention/conviction/punishment etc. and / or nature of the case pending in the Court/University/Educational Authority at the time of filling this form?",
                                            placeholder: "Enter here",
                                            autoExpand: false,
                                            tableView: true,
                                            clearOnHide: false,
                                            errors: {
                                                pattern: "Please use alphanumeric characters, spaces, dots, commas, slash and hyphens only"
                                            },
                                            validate: {
                                                pattern: "^[a-zA-Z0-9.,'-/]+(?: [a-zA-Z0-9.,'-/]+)*$",
                                                maxLength: 255
                                            },
                                            key: "disciplinaryDetails11",
                                            type: "textarea",
                                            input: true
                                        }
                                    ],
                                    size: "md",
                                    width: 12,
                                    offset: 0,
                                    push: 0,
                                    pull: 0,
                                    currentWidth: 12
                                }
                            ],
                            autoAdjust: true,
                            key: "disciplinaryDetailsColumns",
                            type: "columns",
                            input: false,
                            tableView: false
                        }
                    ]
                }
            }
        }
    },
    acknowledgementFields: {
        title: "Acknowledgement",
        weight: 7,
        components: {
            acknowledgement: {
                title: "Acknowledgement",
                input: false,
                icon: "check-square",
                schema: {
                    label: "I hereby declare that the above information submitted are true to the best of my belief and knowledge and I accept all the terms and conditions as mentioned in the detailed advertisement.",
                    type: "checkbox",
                    key: "previewAck",
                    input: true,
                    errors: {
                        required: "This field is required. Try again."
                    },
                    validate: {
                        required: true,
                    },
                    tableView: false,
                    customClass: "text-justify",
                    defaultValue: false
                }
            }
        }
    },
};